export interface ProductSubCategoryOption { value: string; label: string; }
export interface ProductCategoryOption { value: string; label: string; commissionRate: number; commissionLabel: string; icon: string; subCategories: ProductSubCategoryOption[]; }

// Current published Amazon.in standard fee guidance. Rates can change and product-level exclusions may apply.
export const PRODUCT_CATEGORIES: ProductCategoryOption[] = [
  {
    value: "apparel-accessories",
    label: "Apparel & Accessories",
    commissionRate: 10.0,
    commissionLabel: "Highest standard tier \u2014 currently 10%",
    icon: "\ud83d\udc57",
    subCategories: [
      { value: "women-s-clothing", label: "Women's Clothing" },
      { value: "men-s-clothing", label: "Men's Clothing" },
      { value: "kids-clothing", label: "Kids' Clothing" },
      { value: "ethnic-wear", label: "Ethnic Wear" },
      { value: "western-wear", label: "Western Wear" },
      { value: "activewear", label: "Activewear" },
      { value: "innerwear", label: "Innerwear" },
      { value: "sleepwear", label: "Sleepwear" },
      { value: "winter-wear", label: "Winter Wear" },
      { value: "swimwear", label: "Swimwear" },
      { value: "kurtis-tunics", label: "Kurtis & Tunics" },
      { value: "sarees", label: "Sarees" },
      { value: "salwar-suits", label: "Salwar Suits" },
      { value: "lehengas", label: "Lehengas" },
      { value: "dupattas", label: "Dupattas" },
      { value: "tops", label: "Tops" },
      { value: "shirts", label: "Shirts" },
      { value: "t-shirts", label: "T-Shirts" },
      { value: "jeans", label: "Jeans" },
      { value: "trousers", label: "Trousers" },
      { value: "shorts", label: "Shorts" },
      { value: "skirts", label: "Skirts" },
      { value: "dresses", label: "Dresses" },
      { value: "jumpsuits", label: "Jumpsuits" },
      { value: "blazers", label: "Blazers" },
      { value: "jackets", label: "Jackets" },
      { value: "sweatshirts", label: "Sweatshirts" },
      { value: "hoodies", label: "Hoodies" },
      { value: "sweaters", label: "Sweaters" },
      { value: "track-pants", label: "Track Pants" },
      { value: "leggings", label: "Leggings" },
      { value: "palazzos", label: "Palazzos" },
      { value: "cargo-pants", label: "Cargo Pants" },
      { value: "formal-wear", label: "Formal Wear" },
      { value: "party-wear", label: "Party Wear" },
      { value: "maternity-wear", label: "Maternity Wear" },
      { value: "plus-size-clothing", label: "Plus Size Clothing" },
      { value: "school-uniforms", label: "School Uniforms" },
      { value: "workwear", label: "Workwear" },
      { value: "rainwear", label: "Rainwear" },
      { value: "thermal-wear", label: "Thermal Wear" },
      { value: "sports-jerseys", label: "Sports Jerseys" },
      { value: "sports-shorts", label: "Sports Shorts" },
      { value: "yoga-wear", label: "Yoga Wear" },
      { value: "running-wear", label: "Running Wear" },
      { value: "loungewear", label: "Loungewear" },
      { value: "bathrobes", label: "Bathrobes" },
      { value: "night-suits", label: "Night Suits" },
      { value: "bras", label: "Bras" },
      { value: "panties", label: "Panties" },
      { value: "boxers", label: "Boxers" },
      { value: "briefs", label: "Briefs" },
      { value: "socks", label: "Socks" },
      { value: "tights", label: "Tights" },
      { value: "stockings", label: "Stockings" },
      { value: "belts", label: "Belts" },
      { value: "wallets", label: "Wallets" },
      { value: "caps", label: "Caps" },
      { value: "hats", label: "Hats" },
      { value: "scarves", label: "Scarves" },
      { value: "stoles", label: "Stoles" },
      { value: "gloves", label: "Gloves" },
      { value: "sunglasses", label: "Sunglasses" },
      { value: "eyewear-accessories", label: "Eyewear Accessories" },
      { value: "ties", label: "Ties" },
      { value: "bow-ties", label: "Bow Ties" },
      { value: "pocket-squares", label: "Pocket Squares" },
      { value: "cufflinks", label: "Cufflinks" },
      { value: "hair-accessories", label: "Hair Accessories" },
      { value: "headbands", label: "Headbands" },
      { value: "hair-bands", label: "Hair Bands" },
      { value: "scrunchies", label: "Scrunchies" },
      { value: "fashion-jewellery", label: "Fashion Jewellery" },
      { value: "earrings", label: "Earrings" },
      { value: "necklaces", label: "Necklaces" },
      { value: "bracelets", label: "Bracelets" },
      { value: "rings", label: "Rings" },
      { value: "anklets", label: "Anklets" },
      { value: "brooches", label: "Brooches" },
      { value: "bangles", label: "Bangles" },
      { value: "charms", label: "Charms" },
      { value: "costume-accessories", label: "Costume Accessories" },
      { value: "handkerchiefs", label: "Handkerchiefs" },
      { value: "suspenders", label: "Suspenders" },
      { value: "garters", label: "Garters" },
      { value: "travel-organizers", label: "Travel Organizers" },
      { value: "fashion-masks", label: "Fashion Masks" },
      { value: "costume-wear", label: "Costume Wear" },
      { value: "traditional-men-s-wear", label: "Traditional Men's Wear" },
      { value: "traditional-women-s-wear", label: "Traditional Women's Wear" },
      { value: "traditional-kids-wear", label: "Traditional Kids' Wear" },
      { value: "bridal-wear", label: "Bridal Wear" },
      { value: "festive-wear", label: "Festive Wear" },
      { value: "office-wear", label: "Office Wear" },
      { value: "casual-wear", label: "Casual Wear" },
      { value: "denim-wear", label: "Denim Wear" },
      { value: "streetwear", label: "Streetwear" },
    ],
  },
  {
    value: "shoes",
    label: "Shoes",
    commissionRate: 10.0,
    commissionLabel: "Highest standard tier \u2014 currently 10%",
    icon: "\ud83d\udc5f",
    subCategories: [
      { value: "men-s-shoes", label: "Men's Shoes" },
      { value: "women-s-shoes", label: "Women's Shoes" },
      { value: "kids-shoes", label: "Kids' Shoes" },
      { value: "running-shoes", label: "Running Shoes" },
      { value: "walking-shoes", label: "Walking Shoes" },
      { value: "training-shoes", label: "Training Shoes" },
      { value: "sports-shoes", label: "Sports Shoes" },
      { value: "football-shoes", label: "Football Shoes" },
      { value: "cricket-shoes", label: "Cricket Shoes" },
      { value: "basketball-shoes", label: "Basketball Shoes" },
      { value: "tennis-shoes", label: "Tennis Shoes" },
      { value: "badminton-shoes", label: "Badminton Shoes" },
      { value: "cycling-shoes", label: "Cycling Shoes" },
      { value: "golf-shoes", label: "Golf Shoes" },
      { value: "hiking-shoes", label: "Hiking Shoes" },
      { value: "trekking-shoes", label: "Trekking Shoes" },
      { value: "trail-shoes", label: "Trail Shoes" },
      { value: "climbing-shoes", label: "Climbing Shoes" },
      { value: "water-shoes", label: "Water Shoes" },
      { value: "school-shoes", label: "School Shoes" },
      { value: "formal-shoes", label: "Formal Shoes" },
      { value: "office-shoes", label: "Office Shoes" },
      { value: "loafers", label: "Loafers" },
      { value: "derby-shoes", label: "Derby Shoes" },
      { value: "oxford-shoes", label: "Oxford Shoes" },
      { value: "monk-strap-shoes", label: "Monk Strap Shoes" },
      { value: "brogues", label: "Brogues" },
      { value: "moccasins", label: "Moccasins" },
      { value: "slip-on-shoes", label: "Slip-On Shoes" },
      { value: "sneakers", label: "Sneakers" },
      { value: "casual-shoes", label: "Casual Shoes" },
      { value: "canvas-shoes", label: "Canvas Shoes" },
      { value: "boots", label: "Boots" },
      { value: "ankle-boots", label: "Ankle Boots" },
      { value: "chelsea-boots", label: "Chelsea Boots" },
      { value: "combat-boots", label: "Combat Boots" },
      { value: "rain-boots", label: "Rain Boots" },
      { value: "hiking-boots", label: "Hiking Boots" },
      { value: "work-boots", label: "Work Boots" },
      { value: "safety-shoes", label: "Safety Shoes" },
      { value: "sandals", label: "Sandals" },
      { value: "flip-flops", label: "Flip-Flops" },
      { value: "slippers", label: "Slippers" },
      { value: "slides", label: "Slides" },
      { value: "clogs", label: "Clogs" },
      { value: "mules", label: "Mules" },
      { value: "heels", label: "Heels" },
      { value: "pumps", label: "Pumps" },
      { value: "wedges", label: "Wedges" },
      { value: "flats", label: "Flats" },
      { value: "ballerinas", label: "Ballerinas" },
      { value: "juttis", label: "Juttis" },
      { value: "mojaris", label: "Mojaris" },
      { value: "kolhapuris", label: "Kolhapuris" },
      { value: "ethnic-footwear", label: "Ethnic Footwear" },
      { value: "bridal-footwear", label: "Bridal Footwear" },
      { value: "party-footwear", label: "Party Footwear" },
      { value: "beach-footwear", label: "Beach Footwear" },
      { value: "home-footwear", label: "Home Footwear" },
      { value: "orthopedic-footwear", label: "Orthopedic Footwear" },
      { value: "comfort-footwear", label: "Comfort Footwear" },
      { value: "wide-fit-shoes", label: "Wide Fit Shoes" },
      { value: "kids-sandals", label: "Kids' Sandals" },
      { value: "kids-sneakers", label: "Kids' Sneakers" },
      { value: "kids-school-shoes", label: "Kids' School Shoes" },
      { value: "baby-shoes", label: "Baby Shoes" },
      { value: "shoe-care", label: "Shoe Care" },
      { value: "shoe-insoles", label: "Shoe Insoles" },
      { value: "shoe-laces", label: "Shoe Laces" },
      { value: "shoe-trees", label: "Shoe Trees" },
      { value: "shoe-polish", label: "Shoe Polish" },
      { value: "shoe-cleaning-kits", label: "Shoe Cleaning Kits" },
      { value: "heel-grips", label: "Heel Grips" },
      { value: "foot-cushions", label: "Foot Cushions" },
      { value: "shoe-organizers", label: "Shoe Organizers" },
      { value: "shoe-bags", label: "Shoe Bags" },
      { value: "cycling-cleats", label: "Cycling Cleats" },
      { value: "dance-shoes", label: "Dance Shoes" },
      { value: "ballet-shoes", label: "Ballet Shoes" },
      { value: "gym-shoes", label: "Gym Shoes" },
      { value: "boxing-shoes", label: "Boxing Shoes" },
      { value: "wrestling-shoes", label: "Wrestling Shoes" },
      { value: "skating-shoes", label: "Skating Shoes" },
      { value: "horse-riding-boots", label: "Horse Riding Boots" },
      { value: "fishing-boots", label: "Fishing Boots" },
      { value: "snow-boots", label: "Snow Boots" },
      { value: "espadrilles", label: "Espadrilles" },
      { value: "boat-shoes", label: "Boat Shoes" },
      { value: "driving-shoes", label: "Driving Shoes" },
      { value: "chukka-boots", label: "Chukka Boots" },
      { value: "hiking-sandals", label: "Hiking Sandals" },
      { value: "sports-sandals", label: "Sports Sandals" },
      { value: "recovery-footwear", label: "Recovery Footwear" },
      { value: "shoe-accessories", label: "Shoe Accessories" },
    ],
  },
  {
    value: "luggage-bags",
    label: "Luggage & Bags",
    commissionRate: 10.0,
    commissionLabel: "Highest standard tier \u2014 currently 10%",
    icon: "\ud83d\udc5c",
    subCategories: [
      { value: "backpacks", label: "Backpacks" },
      { value: "laptop-backpacks", label: "Laptop Backpacks" },
      { value: "school-backpacks", label: "School Backpacks" },
      { value: "college-backpacks", label: "College Backpacks" },
      { value: "travel-backpacks", label: "Travel Backpacks" },
      { value: "trekking-backpacks", label: "Trekking Backpacks" },
      { value: "camera-backpacks", label: "Camera Backpacks" },
      { value: "anti-theft-backpacks", label: "Anti-Theft Backpacks" },
      { value: "daypacks", label: "Daypacks" },
      { value: "hydration-packs", label: "Hydration Packs" },
      { value: "handbags", label: "Handbags" },
      { value: "shoulder-bags", label: "Shoulder Bags" },
      { value: "tote-bags", label: "Tote Bags" },
      { value: "sling-bags", label: "Sling Bags" },
      { value: "crossbody-bags", label: "Crossbody Bags" },
      { value: "clutches", label: "Clutches" },
      { value: "wallets", label: "Wallets" },
      { value: "card-holders", label: "Card Holders" },
      { value: "coin-purses", label: "Coin Purses" },
      { value: "wristlets", label: "Wristlets" },
      { value: "pouches", label: "Pouches" },
      { value: "cosmetic-bags", label: "Cosmetic Bags" },
      { value: "duffel-bags", label: "Duffel Bags" },
      { value: "gym-bags", label: "Gym Bags" },
      { value: "sports-bags", label: "Sports Bags" },
      { value: "travel-bags", label: "Travel Bags" },
      { value: "weekender-bags", label: "Weekender Bags" },
      { value: "garment-bags", label: "Garment Bags" },
      { value: "laundry-bags", label: "Laundry Bags" },
      { value: "shoe-bags", label: "Shoe Bags" },
      { value: "toiletry-bags", label: "Toiletry Bags" },
      { value: "travel-organizers", label: "Travel Organizers" },
      { value: "packing-cubes", label: "Packing Cubes" },
      { value: "luggage", label: "Luggage" },
      { value: "cabin-luggage", label: "Cabin Luggage" },
      { value: "check-in-luggage", label: "Check-In Luggage" },
      { value: "hard-shell-luggage", label: "Hard-Shell Luggage" },
      { value: "soft-sided-luggage", label: "Soft-Sided Luggage" },
      { value: "spinner-luggage", label: "Spinner Luggage" },
      { value: "trolley-bags", label: "Trolley Bags" },
      { value: "suitcases", label: "Suitcases" },
      { value: "trunk-luggage", label: "Trunk Luggage" },
      { value: "kids-luggage", label: "Kids' Luggage" },
      { value: "laptop-sleeves", label: "Laptop Sleeves" },
      { value: "laptop-bags", label: "Laptop Bags" },
      { value: "messenger-bags", label: "Messenger Bags" },
      { value: "briefcases", label: "Briefcases" },
      { value: "office-bags", label: "Office Bags" },
      { value: "business-bags", label: "Business Bags" },
      { value: "document-bags", label: "Document Bags" },
      { value: "file-folders", label: "File Folders" },
      { value: "portfolio-cases", label: "Portfolio Cases" },
      { value: "camera-bags", label: "Camera Bags" },
      { value: "lens-cases", label: "Lens Cases" },
      { value: "drone-bags", label: "Drone Bags" },
      { value: "musical-instrument-bags", label: "Musical Instrument Bags" },
      { value: "guitar-bags", label: "Guitar Bags" },
      { value: "helmet-bags", label: "Helmet Bags" },
      { value: "tool-bags", label: "Tool Bags" },
      { value: "utility-bags", label: "Utility Bags" },
      { value: "fishing-bags", label: "Fishing Bags" },
      { value: "makeup-cases", label: "Makeup Cases" },
      { value: "jewellery-boxes", label: "Jewellery Boxes" },
      { value: "jewellery-cases", label: "Jewellery Cases" },
      { value: "watch-boxes", label: "Watch Boxes" },
      { value: "vanity-cases", label: "Vanity Cases" },
      { value: "diaper-bags", label: "Diaper Bags" },
      { value: "baby-bags", label: "Baby Bags" },
      { value: "maternity-bags", label: "Maternity Bags" },
      { value: "lunch-bags", label: "Lunch Bags" },
      { value: "insulated-lunch-bags", label: "Insulated Lunch Bags" },
      { value: "cooler-bags", label: "Cooler Bags" },
      { value: "shopping-bags", label: "Shopping Bags" },
      { value: "reusable-shopping-bags", label: "Reusable Shopping Bags" },
      { value: "grocery-bags", label: "Grocery Bags" },
      { value: "foldable-bags", label: "Foldable Bags" },
      { value: "waterproof-bags", label: "Waterproof Bags" },
      { value: "dry-bags", label: "Dry Bags" },
      { value: "bicycle-bags", label: "Bicycle Bags" },
      { value: "saddle-bags", label: "Saddle Bags" },
      { value: "motorcycle-bags", label: "Motorcycle Bags" },
      { value: "tank-bags", label: "Tank Bags" },
      { value: "travel-pouches", label: "Travel Pouches" },
      { value: "passport-holders", label: "Passport Holders" },
      { value: "neck-pouches", label: "Neck Pouches" },
      { value: "money-belts", label: "Money Belts" },
      { value: "rfid-wallets", label: "RFID Wallets" },
      { value: "key-holders", label: "Key Holders" },
      { value: "bag-straps", label: "Bag Straps" },
      { value: "bag-charms", label: "Bag Charms" },
      { value: "bag-rain-covers", label: "Bag Rain Covers" },
      { value: "luggage-covers", label: "Luggage Covers" },
      { value: "luggage-tags", label: "Luggage Tags" },
      { value: "luggage-scales", label: "Luggage Scales" },
      { value: "packing-accessories", label: "Packing Accessories" },
      { value: "travel-accessories", label: "Travel Accessories" },
      { value: "camera-cases", label: "Camera Cases" },
      { value: "tablet-bags", label: "Tablet Bags" },
      { value: "crossbody-pouches", label: "Crossbody Pouches" },
      { value: "waist-bags", label: "Waist Bags" },
      { value: "belt-bags", label: "Belt Bags" },
      { value: "chest-bags", label: "Chest Bags" },
      { value: "trolley-accessories", label: "Trolley Accessories" },
    ],
  },
  {
    value: "watches",
    label: "Watches",
    commissionRate: 10.0,
    commissionLabel: "Highest standard tier \u2014 currently 10%",
    icon: "\u231a",
    subCategories: [
      { value: "analog-watches", label: "Analog Watches" },
      { value: "digital-watches", label: "Digital Watches" },
      { value: "smartwatches", label: "Smartwatches" },
      { value: "fitness-watches", label: "Fitness Watches" },
      { value: "sports-watches", label: "Sports Watches" },
      { value: "chronograph-watches", label: "Chronograph Watches" },
      { value: "automatic-watches", label: "Automatic Watches" },
      { value: "mechanical-watches", label: "Mechanical Watches" },
      { value: "quartz-watches", label: "Quartz Watches" },
      { value: "solar-watches", label: "Solar Watches" },
      { value: "dress-watches", label: "Dress Watches" },
      { value: "casual-watches", label: "Casual Watches" },
      { value: "field-watches", label: "Field Watches" },
      { value: "pilot-watches", label: "Pilot Watches" },
      { value: "diving-watches", label: "Diving Watches" },
      { value: "racing-watches", label: "Racing Watches" },
      { value: "luxury-watches", label: "Luxury Watches" },
      { value: "fashion-watches", label: "Fashion Watches" },
      { value: "minimalist-watches", label: "Minimalist Watches" },
      { value: "classic-watches", label: "Classic Watches" },
      { value: "men-s-watches", label: "Men's Watches" },
      { value: "women-s-watches", label: "Women's Watches" },
      { value: "unisex-watches", label: "Unisex Watches" },
      { value: "kids-watches", label: "Kids' Watches" },
      { value: "couple-watches", label: "Couple Watches" },
      { value: "gift-watches", label: "Gift Watches" },
      { value: "wedding-watches", label: "Wedding Watches" },
      { value: "formal-watches", label: "Formal Watches" },
      { value: "office-watches", label: "Office Watches" },
      { value: "travel-watches", label: "Travel Watches" },
      { value: "smartwatch-bands", label: "Smartwatch Bands" },
      { value: "smartwatch-straps", label: "Smartwatch Straps" },
      { value: "leather-watch-straps", label: "Leather Watch Straps" },
      { value: "metal-watch-straps", label: "Metal Watch Straps" },
      { value: "nylon-watch-straps", label: "Nylon Watch Straps" },
      { value: "silicone-watch-straps", label: "Silicone Watch Straps" },
      { value: "watch-bracelets", label: "Watch Bracelets" },
      { value: "watch-buckles", label: "Watch Buckles" },
      { value: "watch-clasps", label: "Watch Clasps" },
      { value: "watch-cases", label: "Watch Cases" },
      { value: "watch-winders", label: "Watch Winders" },
      { value: "watch-boxes", label: "Watch Boxes" },
      { value: "watch-organizers", label: "Watch Organizers" },
      { value: "watch-display-cases", label: "Watch Display Cases" },
      { value: "watch-tools", label: "Watch Tools" },
      { value: "watch-repair-kits", label: "Watch Repair Kits" },
      { value: "watch-batteries", label: "Watch Batteries" },
      { value: "watch-protectors", label: "Watch Protectors" },
      { value: "smartwatch-screen-protectors", label: "Smartwatch Screen Protectors" },
      { value: "smartwatch-chargers", label: "Smartwatch Chargers" },
      { value: "smartwatch-charging-docks", label: "Smartwatch Charging Docks" },
      { value: "smartwatch-cases", label: "Smartwatch Cases" },
      { value: "smartwatch-covers", label: "Smartwatch Covers" },
      { value: "smartwatch-bumpers", label: "Smartwatch Bumpers" },
      { value: "smartwatch-accessories", label: "Smartwatch Accessories" },
      { value: "fitness-tracker-bands", label: "Fitness Tracker Bands" },
      { value: "fitness-tracker-chargers", label: "Fitness Tracker Chargers" },
      { value: "fitness-tracker-cases", label: "Fitness Tracker Cases" },
      { value: "gps-watches", label: "GPS Watches" },
      { value: "kids-gps-watches", label: "Kids GPS Watches" },
      { value: "running-watches", label: "Running Watches" },
      { value: "cycling-watches", label: "Cycling Watches" },
      { value: "golf-watches", label: "Golf Watches" },
      { value: "swimming-watches", label: "Swimming Watches" },
      { value: "hiking-watches", label: "Hiking Watches" },
      { value: "tactical-watches", label: "Tactical Watches" },
      { value: "outdoor-watches", label: "Outdoor Watches" },
      { value: "adventure-watches", label: "Adventure Watches" },
      { value: "health-monitoring-watches", label: "Health Monitoring Watches" },
      { value: "heart-rate-watches", label: "Heart Rate Watches" },
      { value: "sleep-tracking-watches", label: "Sleep Tracking Watches" },
      { value: "step-counter-watches", label: "Step Counter Watches" },
      { value: "calling-smartwatches", label: "Calling Smartwatches" },
      { value: "bluetooth-smartwatches", label: "Bluetooth Smartwatches" },
      { value: "android-compatible-smartwatches", label: "Android Compatible Smartwatches" },
      { value: "iphone-compatible-smartwatches", label: "iPhone Compatible Smartwatches" },
      { value: "wearable-accessories", label: "Wearable Accessories" },
      { value: "watch-gift-sets", label: "Watch Gift Sets" },
      { value: "watch-display-stands", label: "Watch Display Stands" },
      { value: "watch-travel-cases", label: "Watch Travel Cases" },
      { value: "pocket-watches", label: "Pocket Watches" },
      { value: "pendant-watches", label: "Pendant Watches" },
      { value: "fob-watches", label: "Fob Watches" },
      { value: "stopwatches", label: "Stopwatches" },
      { value: "alarm-watches", label: "Alarm Watches" },
      { value: "clock-watches", label: "Clock Watches" },
      { value: "sports-timer-watches", label: "Sports Timer Watches" },
      { value: "digital-sports-watches", label: "Digital Sports Watches" },
      { value: "vintage-style-watches", label: "Vintage Style Watches" },
      { value: "retro-watches", label: "Retro Watches" },
      { value: "kids-digital-watches", label: "Kids Digital Watches" },
      { value: "kids-analog-watches", label: "Kids Analog Watches" },
      { value: "women-s-smartwatches", label: "Women's Smartwatches" },
      { value: "men-s-smartwatches", label: "Men's Smartwatches" },
      { value: "smartwatch-screen-guards", label: "Smartwatch Screen Guards" },
      { value: "smartwatch-charging-cables", label: "Smartwatch Charging Cables" },
      { value: "watch-cleaning-kits", label: "Watch Cleaning Kits" },
      { value: "watch-polishing-cloths", label: "Watch Polishing Cloths" },
      { value: "watch-storage-cases", label: "Watch Storage Cases" },
      { value: "watch-gift-boxes", label: "Watch Gift Boxes" },
    ],
  },
  {
    value: "beauty",
    label: "Beauty",
    commissionRate: 10.0,
    commissionLabel: "Highest standard tier \u2014 currently 10%",
    icon: "\ud83d\udc84",
    subCategories: [
      { value: "skincare", label: "Skincare" },
      { value: "face-care", label: "Face Care" },
      { value: "body-care", label: "Body Care" },
      { value: "hair-care", label: "Hair Care" },
      { value: "makeup", label: "Makeup" },
      { value: "fragrance", label: "Fragrance" },
      { value: "personal-care", label: "Personal Care" },
      { value: "men-s-grooming", label: "Men's Grooming" },
      { value: "women-s-grooming", label: "Women's Grooming" },
      { value: "bath-shower", label: "Bath & Shower" },
      { value: "face-wash", label: "Face Wash" },
      { value: "cleansers", label: "Cleansers" },
      { value: "toners", label: "Toners" },
      { value: "serums", label: "Serums" },
      { value: "moisturizers", label: "Moisturizers" },
      { value: "face-creams", label: "Face Creams" },
      { value: "face-oils", label: "Face Oils" },
      { value: "face-masks", label: "Face Masks" },
      { value: "scrubs", label: "Scrubs" },
      { value: "exfoliators", label: "Exfoliators" },
      { value: "sunscreen", label: "Sunscreen" },
      { value: "sun-protection", label: "Sun Protection" },
      { value: "lip-care", label: "Lip Care" },
      { value: "eye-care", label: "Eye Care" },
      { value: "acne-care", label: "Acne Care" },
      { value: "anti-aging-care", label: "Anti-Aging Care" },
      { value: "skin-brightening", label: "Skin Brightening" },
      { value: "body-lotions", label: "Body Lotions" },
      { value: "body-oils", label: "Body Oils" },
      { value: "body-scrubs", label: "Body Scrubs" },
      { value: "body-wash", label: "Body Wash" },
      { value: "soaps", label: "Soaps" },
      { value: "hand-wash", label: "Hand Wash" },
      { value: "hand-creams", label: "Hand Creams" },
      { value: "foot-care", label: "Foot Care" },
      { value: "hair-shampoo", label: "Hair Shampoo" },
      { value: "hair-conditioner", label: "Hair Conditioner" },
      { value: "hair-masks", label: "Hair Masks" },
      { value: "hair-oils", label: "Hair Oils" },
      { value: "hair-serums", label: "Hair Serums" },
      { value: "hair-styling", label: "Hair Styling" },
      { value: "hair-color", label: "Hair Color" },
      { value: "hair-treatment", label: "Hair Treatment" },
      { value: "anti-dandruff", label: "Anti-Dandruff" },
      { value: "hair-brushes", label: "Hair Brushes" },
      { value: "combs", label: "Combs" },
      { value: "hair-drying", label: "Hair Drying" },
      { value: "hair-accessories", label: "Hair Accessories" },
      { value: "makeup-foundation", label: "Makeup Foundation" },
      { value: "bb-cream", label: "BB Cream" },
      { value: "cc-cream", label: "CC Cream" },
      { value: "concealer", label: "Concealer" },
      { value: "face-powder", label: "Face Powder" },
      { value: "blush", label: "Blush" },
      { value: "bronzer", label: "Bronzer" },
      { value: "highlighter", label: "Highlighter" },
      { value: "contour", label: "Contour" },
      { value: "primer", label: "Primer" },
      { value: "setting-spray", label: "Setting Spray" },
      { value: "makeup-remover", label: "Makeup Remover" },
      { value: "mascara", label: "Mascara" },
      { value: "eyeliner", label: "Eyeliner" },
      { value: "eye-shadow", label: "Eye Shadow" },
      { value: "kajal", label: "Kajal" },
      { value: "eyebrow-products", label: "Eyebrow Products" },
      { value: "false-eyelashes", label: "False Eyelashes" },
      { value: "lipstick", label: "Lipstick" },
      { value: "lip-gloss", label: "Lip Gloss" },
      { value: "lip-liner", label: "Lip Liner" },
      { value: "lip-balm", label: "Lip Balm" },
      { value: "nail-polish", label: "Nail Polish" },
      { value: "nail-care", label: "Nail Care" },
      { value: "makeup-brushes", label: "Makeup Brushes" },
      { value: "makeup-sponges", label: "Makeup Sponges" },
      { value: "makeup-tools", label: "Makeup Tools" },
      { value: "makeup-kits", label: "Makeup Kits" },
      { value: "beauty-gift-sets", label: "Beauty Gift Sets" },
      { value: "perfume", label: "Perfume" },
      { value: "eau-de-parfum", label: "Eau de Parfum" },
      { value: "eau-de-toilette", label: "Eau de Toilette" },
      { value: "body-mists", label: "Body Mists" },
      { value: "deodorants", label: "Deodorants" },
      { value: "attars", label: "Attars" },
      { value: "men-s-perfume", label: "Men's Perfume" },
      { value: "women-s-perfume", label: "Women's Perfume" },
      { value: "unisex-fragrance", label: "Unisex Fragrance" },
      { value: "fragrance-gift-sets", label: "Fragrance Gift Sets" },
      { value: "bath-salts", label: "Bath Salts" },
      { value: "bath-bombs", label: "Bath Bombs" },
      { value: "shower-gel", label: "Shower Gel" },
      { value: "shower-cream", label: "Shower Cream" },
      { value: "body-scrub", label: "Body Scrub" },
      { value: "loofahs", label: "Loofahs" },
      { value: "bath-accessories", label: "Bath Accessories" },
      { value: "beard-care", label: "Beard Care" },
      { value: "beard-oil", label: "Beard Oil" },
      { value: "beard-balm", label: "Beard Balm" },
      { value: "beard-wash", label: "Beard Wash" },
      { value: "shaving-cream", label: "Shaving Cream" },
      { value: "shaving-gel", label: "Shaving Gel" },
      { value: "razors", label: "Razors" },
      { value: "aftershave", label: "Aftershave" },
      { value: "trimmers", label: "Trimmers" },
      { value: "grooming-kits", label: "Grooming Kits" },
      { value: "nose-trimmers", label: "Nose Trimmers" },
      { value: "ear-trimmers", label: "Ear Trimmers" },
      { value: "manicure-kits", label: "Manicure Kits" },
      { value: "pedicure-kits", label: "Pedicure Kits" },
      { value: "tweezers", label: "Tweezers" },
      { value: "eyelash-curlers", label: "Eyelash Curlers" },
      { value: "facial-tools", label: "Facial Tools" },
      { value: "face-rollers", label: "Face Rollers" },
      { value: "gua-sha", label: "Gua Sha" },
      { value: "beauty-organizers", label: "Beauty Organizers" },
      { value: "cosmetic-pouches", label: "Cosmetic Pouches" },
      { value: "travel-beauty-kits", label: "Travel Beauty Kits" },
    ],
  },
  {
    value: "kitchen",
    label: "Kitchen",
    commissionRate: 5.0,
    commissionLabel: "Standard tier \u2014 currently 5%",
    icon: "\ud83c\udf73",
    subCategories: [
      { value: "cookware", label: "Cookware" },
      { value: "pressure-cookers", label: "Pressure Cookers" },
      { value: "induction-cookware", label: "Induction Cookware" },
      { value: "non-stick-cookware", label: "Non-Stick Cookware" },
      { value: "stainless-steel-cookware", label: "Stainless Steel Cookware" },
      { value: "cast-iron-cookware", label: "Cast Iron Cookware" },
      { value: "saucepans", label: "Saucepans" },
      { value: "frying-pans", label: "Frying Pans" },
      { value: "tawas", label: "Tawas" },
      { value: "woks", label: "Woks" },
      { value: "kadhai", label: "Kadhai" },
      { value: "stock-pots", label: "Stock Pots" },
      { value: "dutch-ovens", label: "Dutch Ovens" },
      { value: "cookware-sets", label: "Cookware Sets" },
      { value: "kitchen-knives", label: "Kitchen Knives" },
      { value: "chef-knives", label: "Chef Knives" },
      { value: "knife-sets", label: "Knife Sets" },
      { value: "cutting-boards", label: "Cutting Boards" },
      { value: "chopping-tools", label: "Chopping Tools" },
      { value: "peelers", label: "Peelers" },
      { value: "graters", label: "Graters" },
      { value: "slicers", label: "Slicers" },
      { value: "choppers", label: "Choppers" },
      { value: "mandolines", label: "Mandolines" },
      { value: "kitchen-scales", label: "Kitchen Scales" },
      { value: "measuring-cups", label: "Measuring Cups" },
      { value: "measuring-spoons", label: "Measuring Spoons" },
      { value: "mixing-bowls", label: "Mixing Bowls" },
      { value: "colanders", label: "Colanders" },
      { value: "strainers", label: "Strainers" },
      { value: "sieves", label: "Sieves" },
      { value: "funnels", label: "Funnels" },
      { value: "kitchen-tongs", label: "Kitchen Tongs" },
      { value: "spatulas", label: "Spatulas" },
      { value: "ladles", label: "Ladles" },
      { value: "whisks", label: "Whisks" },
      { value: "rolling-pins", label: "Rolling Pins" },
      { value: "mortar-pestle", label: "Mortar & Pestle" },
      { value: "kitchen-storage", label: "Kitchen Storage" },
      { value: "food-containers", label: "Food Containers" },
      { value: "spice-jars", label: "Spice Jars" },
      { value: "oil-dispensers", label: "Oil Dispensers" },
      { value: "water-bottles", label: "Water Bottles" },
      { value: "lunch-boxes", label: "Lunch Boxes" },
      { value: "thermoses", label: "Thermoses" },
      { value: "flasks", label: "Flasks" },
      { value: "tea-storage", label: "Tea Storage" },
      { value: "coffee-storage", label: "Coffee Storage" },
      { value: "dinner-sets", label: "Dinner Sets" },
      { value: "plate-sets", label: "Plate Sets" },
      { value: "bowls", label: "Bowls" },
      { value: "serving-bowls", label: "Serving Bowls" },
      { value: "serving-trays", label: "Serving Trays" },
      { value: "serving-platters", label: "Serving Platters" },
      { value: "cutlery", label: "Cutlery" },
      { value: "spoon-sets", label: "Spoon Sets" },
      { value: "fork-sets", label: "Fork Sets" },
      { value: "knife-sets-tableware", label: "Knife Sets Tableware" },
      { value: "glassware", label: "Glassware" },
      { value: "mugs", label: "Mugs" },
      { value: "cups", label: "Cups" },
      { value: "bakeware", label: "Bakeware" },
      { value: "cake-tins", label: "Cake Tins" },
      { value: "baking-trays", label: "Baking Trays" },
      { value: "loaf-pans", label: "Loaf Pans" },
      { value: "muffin-trays", label: "Muffin Trays" },
      { value: "baking-tools", label: "Baking Tools" },
      { value: "cake-decorating-tools", label: "Cake Decorating Tools" },
      { value: "kitchen-appliances", label: "Kitchen Appliances" },
      { value: "mixers", label: "Mixers" },
      { value: "blenders", label: "Blenders" },
      { value: "juicers", label: "Juicers" },
      { value: "toasters", label: "Toasters" },
      { value: "sandwich-makers", label: "Sandwich Makers" },
      { value: "electric-kettles", label: "Electric Kettles" },
      { value: "coffee-makers", label: "Coffee Makers" },
      { value: "tea-makers", label: "Tea Makers" },
      { value: "air-fryers", label: "Air Fryers" },
      { value: "otg-ovens", label: "OTG Ovens" },
      { value: "microwave-accessories", label: "Microwave Accessories" },
      { value: "kitchen-chimneys", label: "Kitchen Chimneys" },
      { value: "kitchen-organizers", label: "Kitchen Organizers" },
      { value: "dish-racks", label: "Dish Racks" },
      { value: "sink-accessories", label: "Sink Accessories" },
      { value: "cleaning-brushes", label: "Cleaning Brushes" },
      { value: "dishwashing-accessories", label: "Dishwashing Accessories" },
      { value: "garbage-bins", label: "Garbage Bins" },
      { value: "kitchen-towels", label: "Kitchen Towels" },
      { value: "aprons", label: "Aprons" },
      { value: "oven-gloves", label: "Oven Gloves" },
      { value: "silicone-mats", label: "Silicone Mats" },
      { value: "kitchen-timers", label: "Kitchen Timers" },
      { value: "ice-trays", label: "Ice Trays" },
      { value: "ice-makers", label: "Ice Makers" },
      { value: "water-purifiers", label: "Water Purifiers" },
      { value: "food-processors", label: "Food Processors" },
      { value: "hand-blenders", label: "Hand Blenders" },
      { value: "rice-cookers", label: "Rice Cookers" },
      { value: "electric-cookers", label: "Electric Cookers" },
      { value: "egg-boilers", label: "Egg Boilers" },
      { value: "milk-frothers", label: "Milk Frothers" },
      { value: "grinders", label: "Grinders" },
      { value: "kitchen-scissors", label: "Kitchen Scissors" },
    ],
  },
  {
    value: "furniture",
    label: "Furniture",
    commissionRate: 5.0,
    commissionLabel: "Standard tier \u2014 currently 5%",
    icon: "\ud83d\udecb\ufe0f",
    subCategories: [
      { value: "sofas", label: "Sofas" },
      { value: "sectional-sofas", label: "Sectional Sofas" },
      { value: "sofa-beds", label: "Sofa Beds" },
      { value: "recliners", label: "Recliners" },
      { value: "lounge-chairs", label: "Lounge Chairs" },
      { value: "accent-chairs", label: "Accent Chairs" },
      { value: "dining-chairs", label: "Dining Chairs" },
      { value: "office-chairs", label: "Office Chairs" },
      { value: "gaming-chairs", label: "Gaming Chairs" },
      { value: "bar-chairs", label: "Bar Chairs" },
      { value: "stools", label: "Stools" },
      { value: "benches", label: "Benches" },
      { value: "dining-tables", label: "Dining Tables" },
      { value: "coffee-tables", label: "Coffee Tables" },
      { value: "side-tables", label: "Side Tables" },
      { value: "console-tables", label: "Console Tables" },
      { value: "study-tables", label: "Study Tables" },
      { value: "computer-tables", label: "Computer Tables" },
      { value: "office-desks", label: "Office Desks" },
      { value: "writing-desks", label: "Writing Desks" },
      { value: "standing-desks", label: "Standing Desks" },
      { value: "workstations", label: "Workstations" },
      { value: "bedside-tables", label: "Bedside Tables" },
      { value: "nightstands", label: "Nightstands" },
      { value: "beds", label: "Beds" },
      { value: "single-beds", label: "Single Beds" },
      { value: "double-beds", label: "Double Beds" },
      { value: "queen-beds", label: "Queen Beds" },
      { value: "king-beds", label: "King Beds" },
      { value: "bunk-beds", label: "Bunk Beds" },
      { value: "storage-beds", label: "Storage Beds" },
      { value: "headboards", label: "Headboards" },
      { value: "mattresses", label: "Mattresses" },
      { value: "wardrobes", label: "Wardrobes" },
      { value: "almirahs", label: "Almirahs" },
      { value: "chest-of-drawers", label: "Chest of Drawers" },
      { value: "dressers", label: "Dressers" },
      { value: "cabinets", label: "Cabinets" },
      { value: "bookshelves", label: "Bookshelves" },
      { value: "display-units", label: "Display Units" },
      { value: "tv-units", label: "TV Units" },
      { value: "shoe-racks", label: "Shoe Racks" },
      { value: "kitchen-cabinets", label: "Kitchen Cabinets" },
      { value: "bathroom-cabinets", label: "Bathroom Cabinets" },
      { value: "filing-cabinets", label: "Filing Cabinets" },
      { value: "storage-cabinets", label: "Storage Cabinets" },
      { value: "wall-shelves", label: "Wall Shelves" },
      { value: "floating-shelves", label: "Floating Shelves" },
      { value: "corner-shelves", label: "Corner Shelves" },
      { value: "wall-units", label: "Wall Units" },
      { value: "bean-bags", label: "Bean Bags" },
      { value: "ottomans", label: "Ottomans" },
      { value: "poufs", label: "Poufs" },
      { value: "outdoor-chairs", label: "Outdoor Chairs" },
      { value: "outdoor-tables", label: "Outdoor Tables" },
      { value: "patio-furniture", label: "Patio Furniture" },
      { value: "garden-benches", label: "Garden Benches" },
      { value: "swing-chairs", label: "Swing Chairs" },
      { value: "hammocks", label: "Hammocks" },
      { value: "rocking-chairs", label: "Rocking Chairs" },
      { value: "folding-chairs", label: "Folding Chairs" },
      { value: "folding-tables", label: "Folding Tables" },
      { value: "plastic-chairs", label: "Plastic Chairs" },
      { value: "plastic-tables", label: "Plastic Tables" },
      { value: "kids-furniture", label: "Kids Furniture" },
      { value: "kids-tables", label: "Kids Tables" },
      { value: "kids-chairs", label: "Kids Chairs" },
      { value: "kids-beds", label: "Kids Beds" },
      { value: "nursery-furniture", label: "Nursery Furniture" },
      { value: "computer-chairs", label: "Computer Chairs" },
      { value: "ergonomic-chairs", label: "Ergonomic Chairs" },
      { value: "executive-chairs", label: "Executive Chairs" },
      { value: "visitor-chairs", label: "Visitor Chairs" },
      { value: "conference-tables", label: "Conference Tables" },
      { value: "reception-furniture", label: "Reception Furniture" },
      { value: "study-chairs", label: "Study Chairs" },
      { value: "writing-chairs", label: "Writing Chairs" },
      { value: "bookcases", label: "Bookcases" },
      { value: "bar-cabinets", label: "Bar Cabinets" },
      { value: "kitchen-islands", label: "Kitchen Islands" },
      { value: "trolleys", label: "Trolleys" },
      { value: "serving-carts", label: "Serving Carts" },
      { value: "plant-stands", label: "Plant Stands" },
      { value: "sideboards", label: "Sideboards" },
      { value: "credenzas", label: "Credenzas" },
      { value: "buffets", label: "Buffets" },
      { value: "vanity-tables", label: "Vanity Tables" },
      { value: "makeup-tables", label: "Makeup Tables" },
      { value: "dressing-tables", label: "Dressing Tables" },
      { value: "dressing-stools", label: "Dressing Stools" },
      { value: "storage-ottomans", label: "Storage Ottomans" },
      { value: "furniture-protectors", label: "Furniture Protectors" },
      { value: "chair-covers", label: "Chair Covers" },
      { value: "sofa-covers", label: "Sofa Covers" },
      { value: "table-covers", label: "Table Covers" },
      { value: "furniture-hardware", label: "Furniture Hardware" },
      { value: "drawer-organizers", label: "Drawer Organizers" },
      { value: "furniture-legs", label: "Furniture Legs" },
      { value: "furniture-casters", label: "Furniture Casters" },
      { value: "desk-organizers", label: "Desk Organizers" },
      { value: "desk-accessories", label: "Desk Accessories" },
      { value: "modular-furniture", label: "Modular Furniture" },
      { value: "home-office-furniture", label: "Home Office Furniture" },
    ],
  },
  {
    value: "home",
    label: "Home",
    commissionRate: 5.0,
    commissionLabel: "Standard tier \u2014 currently 5%",
    icon: "\ud83c\udfe0",
    subCategories: [
      { value: "home-decor", label: "Home Decor" },
      { value: "wall-decor", label: "Wall Decor" },
      { value: "wall-art", label: "Wall Art" },
      { value: "paintings", label: "Paintings" },
      { value: "posters", label: "Posters" },
      { value: "photo-frames", label: "Photo Frames" },
      { value: "clocks", label: "Clocks" },
      { value: "mirrors", label: "Mirrors" },
      { value: "decorative-mirrors", label: "Decorative Mirrors" },
      { value: "vases", label: "Vases" },
      { value: "flower-pots", label: "Flower Pots" },
      { value: "planters", label: "Planters" },
      { value: "artificial-plants", label: "Artificial Plants" },
      { value: "candles", label: "Candles" },
      { value: "candle-holders", label: "Candle Holders" },
      { value: "lanterns", label: "Lanterns" },
      { value: "incense-holders", label: "Incense Holders" },
      { value: "diyas", label: "Diyas" },
      { value: "festive-decor", label: "Festive Decor" },
      { value: "diwali-decor", label: "Diwali Decor" },
      { value: "christmas-decor", label: "Christmas Decor" },
      { value: "eid-decor", label: "Eid Decor" },
      { value: "rangoli-decor", label: "Rangoli Decor" },
      { value: "decorative-lights", label: "Decorative Lights" },
      { value: "led-string-lights", label: "LED String Lights" },
      { value: "fairy-lights", label: "Fairy Lights" },
      { value: "table-lamps", label: "Table Lamps" },
      { value: "floor-lamps", label: "Floor Lamps" },
      { value: "desk-lamps", label: "Desk Lamps" },
      { value: "wall-lamps", label: "Wall Lamps" },
      { value: "night-lamps", label: "Night Lamps" },
      { value: "ceiling-lights", label: "Ceiling Lights" },
      { value: "pendant-lights", label: "Pendant Lights" },
      { value: "chandeliers", label: "Chandeliers" },
      { value: "smart-lights", label: "Smart Lights" },
      { value: "light-bulbs", label: "Light Bulbs" },
      { value: "led-bulbs", label: "LED Bulbs" },
      { value: "emergency-lights", label: "Emergency Lights" },
      { value: "home-fragrance", label: "Home Fragrance" },
      { value: "air-fresheners", label: "Air Fresheners" },
      { value: "diffusers", label: "Diffusers" },
      { value: "essential-oil-diffusers", label: "Essential Oil Diffusers" },
      { value: "room-sprays", label: "Room Sprays" },
      { value: "potpourri", label: "Potpourri" },
      { value: "home-textiles", label: "Home Textiles" },
      { value: "bedsheets", label: "Bedsheets" },
      { value: "bed-covers", label: "Bed Covers" },
      { value: "blankets", label: "Blankets" },
      { value: "quilts", label: "Quilts" },
      { value: "comforters", label: "Comforters" },
      { value: "pillows", label: "Pillows" },
      { value: "cushions", label: "Cushions" },
      { value: "cushion-covers", label: "Cushion Covers" },
      { value: "curtains", label: "Curtains" },
      { value: "blackout-curtains", label: "Blackout Curtains" },
      { value: "door-curtains", label: "Door Curtains" },
      { value: "rugs", label: "Rugs" },
      { value: "carpets", label: "Carpets" },
      { value: "doormats", label: "Doormats" },
      { value: "bath-mats", label: "Bath Mats" },
      { value: "towels", label: "Towels" },
      { value: "bath-towels", label: "Bath Towels" },
      { value: "hand-towels", label: "Hand Towels" },
      { value: "kitchen-towels", label: "Kitchen Towels" },
      { value: "table-runners", label: "Table Runners" },
      { value: "table-cloths", label: "Table Cloths" },
      { value: "napkins", label: "Napkins" },
      { value: "storage-baskets", label: "Storage Baskets" },
      { value: "laundry-baskets", label: "Laundry Baskets" },
      { value: "laundry-hampers", label: "Laundry Hampers" },
      { value: "storage-boxes", label: "Storage Boxes" },
      { value: "plastic-storage", label: "Plastic Storage" },
      { value: "closet-organizers", label: "Closet Organizers" },
      { value: "drawer-organizers", label: "Drawer Organizers" },
      { value: "bathroom-organizers", label: "Bathroom Organizers" },
      { value: "desk-organizers", label: "Desk Organizers" },
      { value: "kitchen-organizers", label: "Kitchen Organizers" },
      { value: "cleaning-supplies", label: "Cleaning Supplies" },
      { value: "cleaning-tools", label: "Cleaning Tools" },
      { value: "mops", label: "Mops" },
      { value: "brooms", label: "Brooms" },
      { value: "dustpans", label: "Dustpans" },
      { value: "vacuum-accessories", label: "Vacuum Accessories" },
      { value: "laundry-accessories", label: "Laundry Accessories" },
      { value: "ironing-boards", label: "Ironing Boards" },
      { value: "clothes-hangers", label: "Clothes Hangers" },
      { value: "garment-covers", label: "Garment Covers" },
      { value: "shoe-organizers", label: "Shoe Organizers" },
      { value: "bathroom-accessories", label: "Bathroom Accessories" },
      { value: "bathroom-sets", label: "Bathroom Sets" },
      { value: "shower-curtains", label: "Shower Curtains" },
      { value: "toilet-accessories", label: "Toilet Accessories" },
      { value: "soap-dispensers", label: "Soap Dispensers" },
      { value: "tissue-holders", label: "Tissue Holders" },
      { value: "toilet-paper-holders", label: "Toilet Paper Holders" },
      { value: "home-safety", label: "Home Safety" },
      { value: "door-locks", label: "Door Locks" },
      { value: "door-stoppers", label: "Door Stoppers" },
      { value: "door-bells", label: "Door Bells" },
      { value: "smoke-alarms", label: "Smoke Alarms" },
      { value: "fire-extinguishers", label: "Fire Extinguishers" },
      { value: "safes", label: "Safes" },
      { value: "home-improvement", label: "Home Improvement" },
      { value: "hardware", label: "Hardware" },
      { value: "adhesives", label: "Adhesives" },
      { value: "hooks", label: "Hooks" },
      { value: "wall-hooks", label: "Wall Hooks" },
      { value: "picture-hanging", label: "Picture Hanging" },
      { value: "window-accessories", label: "Window Accessories" },
      { value: "curtain-rods", label: "Curtain Rods" },
      { value: "blind-accessories", label: "Blind Accessories" },
      { value: "garden-decor", label: "Garden Decor" },
      { value: "garden-tools", label: "Garden Tools" },
      { value: "plant-care", label: "Plant Care" },
      { value: "outdoor-lighting", label: "Outdoor Lighting" },
      { value: "outdoor-storage", label: "Outdoor Storage" },
      { value: "pest-control-products", label: "Pest Control Products" },
      { value: "insect-screens", label: "Insect Screens" },
      { value: "mosquito-nets", label: "Mosquito Nets" },
      { value: "fans", label: "Fans" },
      { value: "heaters", label: "Heaters" },
      { value: "humidifiers", label: "Humidifiers" },
      { value: "dehumidifiers", label: "Dehumidifiers" },
    ],
  },
  {
    value: "books",
    label: "Books",
    commissionRate: 5.9,
    commissionLabel: "Standard tier \u2014 currently 5.9%",
    icon: "\ud83d\udcda",
    subCategories: [
      { value: "fiction-books", label: "Fiction Books" },
      { value: "literary-fiction", label: "Literary Fiction" },
      { value: "romance", label: "Romance" },
      { value: "mystery-thriller", label: "Mystery & Thriller" },
      { value: "crime-fiction", label: "Crime Fiction" },
      { value: "science-fiction", label: "Science Fiction" },
      { value: "fantasy", label: "Fantasy" },
      { value: "historical-fiction", label: "Historical Fiction" },
      { value: "young-adult-fiction", label: "Young Adult Fiction" },
      { value: "children-s-fiction", label: "Children's Fiction" },
      { value: "short-stories", label: "Short Stories" },
      { value: "novellas", label: "Novellas" },
      { value: "poetry", label: "Poetry" },
      { value: "drama", label: "Drama" },
      { value: "classic-literature", label: "Classic Literature" },
      { value: "indian-literature", label: "Indian Literature" },
      { value: "regional-literature", label: "Regional Literature" },
      { value: "hindi-books", label: "Hindi Books" },
      { value: "english-books", label: "English Books" },
      { value: "bengali-books", label: "Bengali Books" },
      { value: "tamil-books", label: "Tamil Books" },
      { value: "telugu-books", label: "Telugu Books" },
      { value: "marathi-books", label: "Marathi Books" },
      { value: "malayalam-books", label: "Malayalam Books" },
      { value: "kannada-books", label: "Kannada Books" },
      { value: "gujarati-books", label: "Gujarati Books" },
      { value: "punjabi-books", label: "Punjabi Books" },
      { value: "urdu-books", label: "Urdu Books" },
      { value: "biographies", label: "Biographies" },
      { value: "autobiographies", label: "Autobiographies" },
      { value: "memoirs", label: "Memoirs" },
      { value: "history-books", label: "History Books" },
      { value: "world-history", label: "World History" },
      { value: "indian-history", label: "Indian History" },
      { value: "ancient-history", label: "Ancient History" },
      { value: "medieval-history", label: "Medieval History" },
      { value: "modern-history", label: "Modern History" },
      { value: "political-science", label: "Political Science" },
      { value: "economics", label: "Economics" },
      { value: "psychology", label: "Psychology" },
      { value: "sociology", label: "Sociology" },
      { value: "philosophy", label: "Philosophy" },
      { value: "religion-spirituality", label: "Religion & Spirituality" },
      { value: "hinduism-books", label: "Hinduism Books" },
      { value: "islam-books", label: "Islam Books" },
      { value: "christianity-books", label: "Christianity Books" },
      { value: "buddhism-books", label: "Buddhism Books" },
      { value: "jainism-books", label: "Jainism Books" },
      { value: "sikhism-books", label: "Sikhism Books" },
      { value: "self-help", label: "Self-Help" },
      { value: "personal-development", label: "Personal Development" },
      { value: "motivational-books", label: "Motivational Books" },
      { value: "business-books", label: "Business Books" },
      { value: "management-books", label: "Management Books" },
      { value: "finance-books", label: "Finance Books" },
      { value: "investing-books", label: "Investing Books" },
      { value: "entrepreneurship", label: "Entrepreneurship" },
      { value: "marketing-books", label: "Marketing Books" },
      { value: "leadership-books", label: "Leadership Books" },
      { value: "communication-books", label: "Communication Books" },
      { value: "career-guides", label: "Career Guides" },
      { value: "interview-preparation", label: "Interview Preparation" },
      { value: "competitive-exams", label: "Competitive Exams" },
      { value: "upsc-books", label: "UPSC Books" },
      { value: "ssc-books", label: "SSC Books" },
      { value: "banking-exam-books", label: "Banking Exam Books" },
      { value: "railway-exam-books", label: "Railway Exam Books" },
      { value: "defence-exam-books", label: "Defence Exam Books" },
      { value: "teaching-exam-books", label: "Teaching Exam Books" },
      { value: "engineering-books", label: "Engineering Books" },
      { value: "medical-books", label: "Medical Books" },
      { value: "law-books", label: "Law Books" },
      { value: "computer-science-books", label: "Computer Science Books" },
      { value: "programming-books", label: "Programming Books" },
      { value: "web-development-books", label: "Web Development Books" },
      { value: "data-science-books", label: "Data Science Books" },
      { value: "artificial-intelligence-books", label: "Artificial Intelligence Books" },
      { value: "cloud-computing-books", label: "Cloud Computing Books" },
      { value: "cybersecurity-books", label: "Cybersecurity Books" },
      { value: "database-books", label: "Database Books" },
      { value: "mathematics-books", label: "Mathematics Books" },
      { value: "physics-books", label: "Physics Books" },
      { value: "chemistry-books", label: "Chemistry Books" },
      { value: "biology-books", label: "Biology Books" },
      { value: "school-books", label: "School Books" },
      { value: "children-s-learning", label: "Children's Learning" },
      { value: "activity-books", label: "Activity Books" },
      { value: "coloring-books", label: "Coloring Books" },
      { value: "puzzle-books", label: "Puzzle Books" },
      { value: "cookbooks", label: "Cookbooks" },
      { value: "travel-books", label: "Travel Books" },
      { value: "photography-books", label: "Photography Books" },
      { value: "art-books", label: "Art Books" },
      { value: "craft-books", label: "Craft Books" },
      { value: "music-books", label: "Music Books" },
      { value: "language-learning", label: "Language Learning" },
      { value: "dictionary-books", label: "Dictionary Books" },
      { value: "grammar-books", label: "Grammar Books" },
      { value: "stationery-books", label: "Stationery Books" },
      { value: "study-guides", label: "Study Guides" },
      { value: "textbooks", label: "Textbooks" },
      { value: "reference-books", label: "Reference Books" },
      { value: "atlases", label: "Atlases" },
      { value: "encyclopedias", label: "Encyclopedias" },
      { value: "comics-graphic-novels", label: "Comics & Graphic Novels" },
    ],
  },
  {
    value: "toys",
    label: "Toys",
    commissionRate: 5.9,
    commissionLabel: "Standard tier \u2014 currently 5.9%",
    icon: "\ud83e\uddf8",
    subCategories: [
      { value: "action-figures", label: "Action Figures" },
      { value: "dolls", label: "Dolls" },
      { value: "doll-houses", label: "Doll Houses" },
      { value: "doll-accessories", label: "Doll Accessories" },
      { value: "toy-cars", label: "Toy Cars" },
      { value: "remote-control-cars", label: "Remote Control Cars" },
      { value: "remote-control-toys", label: "Remote Control Toys" },
      { value: "toy-trucks", label: "Toy Trucks" },
      { value: "toy-bikes", label: "Toy Bikes" },
      { value: "toy-aircraft", label: "Toy Aircraft" },
      { value: "toy-trains", label: "Toy Trains" },
      { value: "building-blocks", label: "Building Blocks" },
      { value: "construction-sets", label: "Construction Sets" },
      { value: "stem-toys", label: "STEM Toys" },
      { value: "science-kits", label: "Science Kits" },
      { value: "math-learning-toys", label: "Math Learning Toys" },
      { value: "educational-toys", label: "Educational Toys" },
      { value: "learning-games", label: "Learning Games" },
      { value: "board-games", label: "Board Games" },
      { value: "card-games", label: "Card Games" },
      { value: "puzzles", label: "Puzzles" },
      { value: "jigsaw-puzzles", label: "Jigsaw Puzzles" },
      { value: "3d-puzzles", label: "3D Puzzles" },
      { value: "strategy-games", label: "Strategy Games" },
      { value: "family-games", label: "Family Games" },
      { value: "party-games", label: "Party Games" },
      { value: "outdoor-games", label: "Outdoor Games" },
      { value: "sports-toys", label: "Sports Toys" },
      { value: "ride-on-toys", label: "Ride-On Toys" },
      { value: "scooters", label: "Scooters" },
      { value: "tricycles", label: "Tricycles" },
      { value: "bicycles-for-kids", label: "Bicycles for Kids" },
      { value: "balance-bikes", label: "Balance Bikes" },
      { value: "skateboards", label: "Skateboards" },
      { value: "roller-skates", label: "Roller Skates" },
      { value: "play-tents", label: "Play Tents" },
      { value: "playhouses", label: "Playhouses" },
      { value: "pretend-play", label: "Pretend Play" },
      { value: "kitchen-play-sets", label: "Kitchen Play Sets" },
      { value: "doctor-play-sets", label: "Doctor Play Sets" },
      { value: "tool-play-sets", label: "Tool Play Sets" },
      { value: "makeup-pretend-play", label: "Makeup Pretend Play" },
      { value: "musical-toys", label: "Musical Toys" },
      { value: "toy-instruments", label: "Toy Instruments" },
      { value: "electronic-toys", label: "Electronic Toys" },
      { value: "interactive-toys", label: "Interactive Toys" },
      { value: "robot-toys", label: "Robot Toys" },
      { value: "coding-toys", label: "Coding Toys" },
      { value: "remote-control-robots", label: "Remote Control Robots" },
      { value: "toy-drones", label: "Toy Drones" },
      { value: "toy-guns-blasters", label: "Toy Guns & Blasters" },
      { value: "water-toys", label: "Water Toys" },
      { value: "bath-toys", label: "Bath Toys" },
      { value: "beach-toys", label: "Beach Toys" },
      { value: "sand-toys", label: "Sand Toys" },
      { value: "art-craft-kits", label: "Art & Craft Kits" },
      { value: "drawing-kits", label: "Drawing Kits" },
      { value: "painting-kits", label: "Painting Kits" },
      { value: "clay-dough", label: "Clay & Dough" },
      { value: "slime-kits", label: "Slime Kits" },
      { value: "sticker-books", label: "Sticker Books" },
      { value: "coloring-kits", label: "Coloring Kits" },
      { value: "activity-books", label: "Activity Books" },
      { value: "flash-cards", label: "Flash Cards" },
      { value: "alphabet-toys", label: "Alphabet Toys" },
      { value: "number-toys", label: "Number Toys" },
      { value: "montessori-toys", label: "Montessori Toys" },
      { value: "sensory-toys", label: "Sensory Toys" },
      { value: "baby-toys", label: "Baby Toys" },
      { value: "teethers", label: "Teethers" },
      { value: "rattles", label: "Rattles" },
      { value: "stacking-toys", label: "Stacking Toys" },
      { value: "shape-sorters", label: "Shape Sorters" },
      { value: "push-pull-toys", label: "Push & Pull Toys" },
      { value: "baby-activity-centers", label: "Baby Activity Centers" },
      { value: "soft-toys", label: "Soft Toys" },
      { value: "plush-toys", label: "Plush Toys" },
      { value: "teddy-bears", label: "Teddy Bears" },
      { value: "stuffed-animals", label: "Stuffed Animals" },
      { value: "collectible-figures", label: "Collectible Figures" },
      { value: "die-cast-vehicles", label: "Die-Cast Vehicles" },
      { value: "model-kits", label: "Model Kits" },
      { value: "scale-models", label: "Scale Models" },
      { value: "magic-kits", label: "Magic Kits" },
      { value: "science-experiments", label: "Science Experiments" },
      { value: "remote-control-boats", label: "Remote Control Boats" },
      { value: "remote-control-helicopters", label: "Remote Control Helicopters" },
      { value: "rc-crawlers", label: "RC Crawlers" },
      { value: "toy-cameras", label: "Toy Cameras" },
      { value: "kids-binoculars", label: "Kids' Binoculars" },
      { value: "kids-telescopes", label: "Kids' Telescopes" },
      { value: "kids-microscopes", label: "Kids' Microscopes" },
      { value: "kids-watches", label: "Kids' Watches" },
      { value: "kids-walkie-talkies", label: "Kids' Walkie Talkies" },
      { value: "play-mats", label: "Play Mats" },
      { value: "doll-strollers", label: "Doll Strollers" },
      { value: "doll-furniture", label: "Doll Furniture" },
      { value: "toy-storage", label: "Toy Storage" },
      { value: "kids-party-supplies", label: "Kids' Party Supplies" },
      { value: "educational-flashcards", label: "Educational Flashcards" },
      { value: "memory-games", label: "Memory Games" },
      { value: "word-games", label: "Word Games" },
      { value: "travel-games", label: "Travel Games" },
    ],
  },
  {
    value: "personal-care-appliances",
    label: "Personal Care Appliances",
    commissionRate: 5.9,
    commissionLabel: "Standard tier \u2014 currently 5.9%",
    icon: "\ud83d\udc87",
    subCategories: [
      { value: "hair-dryers", label: "Hair Dryers" },
      { value: "hair-straighteners", label: "Hair Straighteners" },
      { value: "hair-curlers", label: "Hair Curlers" },
      { value: "hair-crimpers", label: "Hair Crimpers" },
      { value: "hot-air-brushes", label: "Hot Air Brushes" },
      { value: "hair-stylers", label: "Hair Stylers" },
      { value: "hair-clippers", label: "Hair Clippers" },
      { value: "hair-trimmers", label: "Hair Trimmers" },
      { value: "beard-trimmers", label: "Beard Trimmers" },
      { value: "body-groomers", label: "Body Groomers" },
      { value: "nose-trimmers", label: "Nose Trimmers" },
      { value: "ear-trimmers", label: "Ear Trimmers" },
      { value: "shavers", label: "Shavers" },
      { value: "electric-shavers", label: "Electric Shavers" },
      { value: "foil-shavers", label: "Foil Shavers" },
      { value: "rotary-shavers", label: "Rotary Shavers" },
      { value: "epilators", label: "Epilators" },
      { value: "ipl-hair-removal", label: "IPL Hair Removal" },
      { value: "electric-toothbrushes", label: "Electric Toothbrushes" },
      { value: "water-flossers", label: "Water Flossers" },
      { value: "oral-irrigators", label: "Oral Irrigators" },
      { value: "toothbrush-heads", label: "Toothbrush Heads" },
      { value: "electric-facial-cleansers", label: "Electric Facial Cleansers" },
      { value: "face-massagers", label: "Face Massagers" },
      { value: "facial-steamers", label: "Facial Steamers" },
      { value: "skin-care-devices", label: "Skin Care Devices" },
      { value: "beauty-devices", label: "Beauty Devices" },
      { value: "manicure-devices", label: "Manicure Devices" },
      { value: "pedicure-devices", label: "Pedicure Devices" },
      { value: "nail-drills", label: "Nail Drills" },
      { value: "nail-dryers", label: "Nail Dryers" },
      { value: "foot-massagers", label: "Foot Massagers" },
      { value: "body-massagers", label: "Body Massagers" },
      { value: "hand-massagers", label: "Hand Massagers" },
      { value: "neck-massagers", label: "Neck Massagers" },
      { value: "back-massagers", label: "Back Massagers" },
      { value: "eye-massagers", label: "Eye Massagers" },
      { value: "massage-guns", label: "Massage Guns" },
      { value: "heating-pads", label: "Heating Pads" },
      { value: "foot-baths", label: "Foot Baths" },
      { value: "sauna-accessories", label: "Sauna Accessories" },
      { value: "electric-heating-belts", label: "Electric Heating Belts" },
      { value: "sleep-devices", label: "Sleep Devices" },
      { value: "white-noise-machines", label: "White Noise Machines" },
      { value: "humidifiers-personal", label: "Humidifiers Personal" },
      { value: "personal-fans", label: "Personal Fans" },
      { value: "portable-air-purifiers", label: "Portable Air Purifiers" },
      { value: "electric-lint-removers", label: "Electric Lint Removers" },
      { value: "fabric-shavers", label: "Fabric Shavers" },
      { value: "garment-steamers", label: "Garment Steamers" },
      { value: "clothes-steamers", label: "Clothes Steamers" },
      { value: "irons", label: "Irons" },
      { value: "travel-irons", label: "Travel Irons" },
      { value: "digital-scales", label: "Digital Scales" },
      { value: "body-weighing-scales", label: "Body Weighing Scales" },
      { value: "kitchen-scales", label: "Kitchen Scales" },
      { value: "blood-pressure-monitors", label: "Blood Pressure Monitors" },
      { value: "pulse-oximeters", label: "Pulse Oximeters" },
      { value: "thermometers", label: "Thermometers" },
      { value: "grooming-kits", label: "Grooming Kits" },
      { value: "travel-grooming-kits", label: "Travel Grooming Kits" },
      { value: "men-s-grooming-appliances", label: "Men's Grooming Appliances" },
      { value: "women-s-grooming-appliances", label: "Women's Grooming Appliances" },
      { value: "unisex-grooming-appliances", label: "Unisex Grooming Appliances" },
      { value: "hair-styling-tools", label: "Hair Styling Tools" },
      { value: "hair-curling-wands", label: "Hair Curling Wands" },
      { value: "hair-diffusers", label: "Hair Diffusers" },
      { value: "hair-dryer-brushes", label: "Hair Dryer Brushes" },
      { value: "hair-removal-devices", label: "Hair Removal Devices" },
      { value: "eyebrow-trimmers", label: "Eyebrow Trimmers" },
      { value: "facial-hair-trimmers", label: "Facial Hair Trimmers" },
      { value: "beard-shapers", label: "Beard Shapers" },
      { value: "beard-straighteners", label: "Beard Straighteners" },
      { value: "beard-brushes-electric", label: "Beard Brushes Electric" },
      { value: "electric-manicure-sets", label: "Electric Manicure Sets" },
      { value: "electric-pedicure-sets", label: "Electric Pedicure Sets" },
      { value: "callus-removers", label: "Callus Removers" },
      { value: "electric-callus-removers", label: "Electric Callus Removers" },
      { value: "foot-files", label: "Foot Files" },
      { value: "foot-spa-machines", label: "Foot Spa Machines" },
      { value: "body-fat-scales", label: "Body Fat Scales" },
      { value: "smart-scales", label: "Smart Scales" },
      { value: "fitness-trackers", label: "Fitness Trackers" },
      { value: "sleep-trackers", label: "Sleep Trackers" },
      { value: "health-monitoring-devices", label: "Health Monitoring Devices" },
      { value: "portable-massagers", label: "Portable Massagers" },
      { value: "rechargeable-grooming-devices", label: "Rechargeable Grooming Devices" },
      { value: "usb-grooming-devices", label: "USB Grooming Devices" },
      { value: "cordless-grooming-devices", label: "Cordless Grooming Devices" },
      { value: "travel-hair-dryers", label: "Travel Hair Dryers" },
      { value: "travel-straighteners", label: "Travel Straighteners" },
      { value: "professional-hair-dryers", label: "Professional Hair Dryers" },
      { value: "salon-hair-tools", label: "Salon Hair Tools" },
      { value: "hair-styling-accessories", label: "Hair Styling Accessories" },
      { value: "appliance-storage-cases", label: "Appliance Storage Cases" },
      { value: "replacement-heads", label: "Replacement Heads" },
      { value: "appliance-chargers", label: "Appliance Chargers" },
    ],
  },
  {
    value: "baby-products",
    label: "Baby Products",
    commissionRate: 5.9,
    commissionLabel: "Standard tier \u2014 currently 5.9%",
    icon: "\ud83d\udc76",
    subCategories: [
      { value: "diapers", label: "Diapers" },
      { value: "newborn-diapers", label: "Newborn Diapers" },
      { value: "baby-wipes", label: "Baby Wipes" },
      { value: "diaper-rash-creams", label: "Diaper Rash Creams" },
      { value: "baby-lotions", label: "Baby Lotions" },
      { value: "baby-oils", label: "Baby Oils" },
      { value: "baby-shampoos", label: "Baby Shampoos" },
      { value: "baby-soaps", label: "Baby Soaps" },
      { value: "baby-wash", label: "Baby Wash" },
      { value: "baby-powder", label: "Baby Powder" },
      { value: "baby-sunscreen", label: "Baby Sunscreen" },
      { value: "baby-skincare", label: "Baby Skincare" },
      { value: "baby-hair-care", label: "Baby Hair Care" },
      { value: "baby-grooming-kits", label: "Baby Grooming Kits" },
      { value: "baby-towels", label: "Baby Towels" },
      { value: "baby-bath-towels", label: "Baby Bath Towels" },
      { value: "baby-blankets", label: "Baby Blankets" },
      { value: "baby-swaddles", label: "Baby Swaddles" },
      { value: "baby-bedding", label: "Baby Bedding" },
      { value: "baby-pillows", label: "Baby Pillows" },
      { value: "baby-mosquito-nets", label: "Baby Mosquito Nets" },
      { value: "baby-clothing", label: "Baby Clothing" },
      { value: "newborn-clothing", label: "Newborn Clothing" },
      { value: "baby-bodysuits", label: "Baby Bodysuits" },
      { value: "baby-rompers", label: "Baby Rompers" },
      { value: "baby-dresses", label: "Baby Dresses" },
      { value: "baby-t-shirts", label: "Baby T-Shirts" },
      { value: "baby-pants", label: "Baby Pants" },
      { value: "baby-socks", label: "Baby Socks" },
      { value: "baby-shoes", label: "Baby Shoes" },
      { value: "baby-caps", label: "Baby Caps" },
      { value: "baby-mittens", label: "Baby Mittens" },
      { value: "baby-bibs", label: "Baby Bibs" },
      { value: "feeding-bottles", label: "Feeding Bottles" },
      { value: "baby-bottle-sets", label: "Baby Bottle Sets" },
      { value: "bottle-sterilizers", label: "Bottle Sterilizers" },
      { value: "bottle-warmers", label: "Bottle Warmers" },
      { value: "breast-pumps", label: "Breast Pumps" },
      { value: "manual-breast-pumps", label: "Manual Breast Pumps" },
      { value: "electric-breast-pumps", label: "Electric Breast Pumps" },
      { value: "nursing-accessories", label: "Nursing Accessories" },
      { value: "nursing-pillows", label: "Nursing Pillows" },
      { value: "baby-formula-accessories", label: "Baby Formula Accessories" },
      { value: "baby-food-storage", label: "Baby Food Storage" },
      { value: "baby-feeding-spoons", label: "Baby Feeding Spoons" },
      { value: "baby-bowls", label: "Baby Bowls" },
      { value: "baby-plates", label: "Baby Plates" },
      { value: "sippy-cups", label: "Sippy Cups" },
      { value: "straw-cups", label: "Straw Cups" },
      { value: "baby-cutlery", label: "Baby Cutlery" },
      { value: "baby-high-chairs", label: "Baby High Chairs" },
      { value: "booster-seats", label: "Booster Seats" },
      { value: "baby-strollers", label: "Baby Strollers" },
      { value: "travel-strollers", label: "Travel Strollers" },
      { value: "jogging-strollers", label: "Jogging Strollers" },
      { value: "twin-strollers", label: "Twin Strollers" },
      { value: "baby-carriers", label: "Baby Carriers" },
      { value: "baby-wraps", label: "Baby Wraps" },
      { value: "baby-slings", label: "Baby Slings" },
      { value: "baby-cots", label: "Baby Cots" },
      { value: "baby-cribs", label: "Baby Cribs" },
      { value: "crib-bedding", label: "Crib Bedding" },
      { value: "baby-mattresses", label: "Baby Mattresses" },
      { value: "changing-tables", label: "Changing Tables" },
      { value: "changing-mats", label: "Changing Mats" },
      { value: "diaper-bags", label: "Diaper Bags" },
      { value: "baby-monitors", label: "Baby Monitors" },
      { value: "video-baby-monitors", label: "Video Baby Monitors" },
      { value: "audio-baby-monitors", label: "Audio Baby Monitors" },
      { value: "baby-safety-gates", label: "Baby Safety Gates" },
      { value: "corner-guards", label: "Corner Guards" },
      { value: "socket-covers", label: "Socket Covers" },
      { value: "cabinet-locks", label: "Cabinet Locks" },
      { value: "baby-proofing-kits", label: "Baby Proofing Kits" },
      { value: "baby-bath-tubs", label: "Baby Bath Tubs" },
      { value: "baby-bath-seats", label: "Baby Bath Seats" },
      { value: "baby-potty-chairs", label: "Baby Potty Chairs" },
      { value: "potty-training", label: "Potty Training" },
      { value: "baby-walkers", label: "Baby Walkers" },
      { value: "baby-rockers", label: "Baby Rockers" },
      { value: "baby-swings", label: "Baby Swings" },
      { value: "bouncers", label: "Bouncers" },
      { value: "playpens", label: "Playpens" },
      { value: "baby-activity-gyms", label: "Baby Activity Gyms" },
      { value: "teethers", label: "Teethers" },
      { value: "rattles", label: "Rattles" },
      { value: "baby-toys", label: "Baby Toys" },
      { value: "soft-baby-toys", label: "Soft Baby Toys" },
      { value: "bath-toys", label: "Bath Toys" },
      { value: "nursery-decor", label: "Nursery Decor" },
      { value: "night-lights-for-baby", label: "Night Lights for Baby" },
      { value: "baby-sound-machines", label: "Baby Sound Machines" },
      { value: "baby-gift-sets", label: "Baby Gift Sets" },
      { value: "maternity-clothing", label: "Maternity Clothing" },
      { value: "maternity-pillows", label: "Maternity Pillows" },
      { value: "maternity-care", label: "Maternity Care" },
      { value: "postpartum-care", label: "Postpartum Care" },
      { value: "pregnancy-books", label: "Pregnancy Books" },
      { value: "baby-care-kits", label: "Baby Care Kits" },
      { value: "newborn-gift-sets", label: "Newborn Gift Sets" },
      { value: "baby-keepsake-items", label: "Baby Keepsake Items" },
      { value: "baby-travel-accessories", label: "Baby Travel Accessories" },
      { value: "baby-laundry-care", label: "Baby Laundry Care" },
    ],
  },
  {
    value: "automotive",
    label: "Automotive",
    commissionRate: 5.9,
    commissionLabel: "Standard tier \u2014 currently 5.9%",
    icon: "\ud83d\ude97",
    subCategories: [
      { value: "car-accessories", label: "Car Accessories" },
      { value: "car-electronics", label: "Car Electronics" },
      { value: "car-audio", label: "Car Audio" },
      { value: "car-speakers", label: "Car Speakers" },
      { value: "car-subwoofers", label: "Car Subwoofers" },
      { value: "car-amplifiers", label: "Car Amplifiers" },
      { value: "car-bluetooth-devices", label: "Car Bluetooth Devices" },
      { value: "car-chargers", label: "Car Chargers" },
      { value: "car-phone-mounts", label: "Car Phone Mounts" },
      { value: "car-dash-cameras", label: "Car Dash Cameras" },
      { value: "car-rear-cameras", label: "Car Rear Cameras" },
      { value: "car-gps-devices", label: "Car GPS Devices" },
      { value: "car-vacuum-cleaners", label: "Car Vacuum Cleaners" },
      { value: "car-air-purifiers", label: "Car Air Purifiers" },
      { value: "car-air-fresheners", label: "Car Air Fresheners" },
      { value: "car-cleaning", label: "Car Cleaning" },
      { value: "car-wash-supplies", label: "Car Wash Supplies" },
      { value: "car-polishes", label: "Car Polishes" },
      { value: "car-waxes", label: "Car Waxes" },
      { value: "car-shampoos", label: "Car Shampoos" },
      { value: "car-detailing-kits", label: "Car Detailing Kits" },
      { value: "microfiber-cloths", label: "Microfiber Cloths" },
      { value: "car-cleaning-brushes", label: "Car Cleaning Brushes" },
      { value: "car-interior-care", label: "Car Interior Care" },
      { value: "car-exterior-care", label: "Car Exterior Care" },
      { value: "dashboard-accessories", label: "Dashboard Accessories" },
      { value: "seat-covers", label: "Seat Covers" },
      { value: "steering-wheel-covers", label: "Steering Wheel Covers" },
      { value: "floor-mats", label: "Floor Mats" },
      { value: "boot-mats", label: "Boot Mats" },
      { value: "car-sunshades", label: "Car Sunshades" },
      { value: "car-curtains", label: "Car Curtains" },
      { value: "car-organizers", label: "Car Organizers" },
      { value: "trunk-organizers", label: "Trunk Organizers" },
      { value: "car-trash-bins", label: "Car Trash Bins" },
      { value: "car-cushions", label: "Car Cushions" },
      { value: "neck-pillows-for-cars", label: "Neck Pillows for Cars" },
      { value: "travel-pillows-for-cars", label: "Travel Pillows for Cars" },
      { value: "car-safety-kits", label: "Car Safety Kits" },
      { value: "first-aid-kits-for-cars", label: "First Aid Kits for Cars" },
      { value: "emergency-kits", label: "Emergency Kits" },
      { value: "jump-starters", label: "Jump Starters" },
      { value: "battery-chargers", label: "Battery Chargers" },
      { value: "tyre-inflators", label: "Tyre Inflators" },
      { value: "air-compressors", label: "Air Compressors" },
      { value: "tyre-pressure-gauges", label: "Tyre Pressure Gauges" },
      { value: "puncture-repair-kits", label: "Puncture Repair Kits" },
      { value: "tyre-accessories", label: "Tyre Accessories" },
      { value: "car-batteries", label: "Car Batteries" },
      { value: "battery-accessories", label: "Battery Accessories" },
      { value: "motorcycle-accessories", label: "Motorcycle Accessories" },
      { value: "motorcycle-helmets", label: "Motorcycle Helmets" },
      { value: "helmet-accessories", label: "Helmet Accessories" },
      { value: "motorcycle-gloves", label: "Motorcycle Gloves" },
      { value: "riding-jackets", label: "Riding Jackets" },
      { value: "riding-pants", label: "Riding Pants" },
      { value: "motorcycle-boots", label: "Motorcycle Boots" },
      { value: "bike-covers", label: "Bike Covers" },
      { value: "motorcycle-covers", label: "Motorcycle Covers" },
      { value: "bike-locks", label: "Bike Locks" },
      { value: "motorcycle-locks", label: "Motorcycle Locks" },
      { value: "chain-locks", label: "Chain Locks" },
      { value: "bike-pumps", label: "Bike Pumps" },
      { value: "bicycle-accessories", label: "Bicycle Accessories" },
      { value: "bicycle-lights", label: "Bicycle Lights" },
      { value: "bicycle-locks", label: "Bicycle Locks" },
      { value: "bicycle-helmets", label: "Bicycle Helmets" },
      { value: "bicycle-bags", label: "Bicycle Bags" },
      { value: "bike-phone-mounts", label: "Bike Phone Mounts" },
      { value: "bike-tools", label: "Bike Tools" },
      { value: "bike-repair-kits", label: "Bike Repair Kits" },
      { value: "car-tools", label: "Car Tools" },
      { value: "mechanic-tools", label: "Mechanic Tools" },
      { value: "obd-scanners", label: "OBD Scanners" },
      { value: "diagnostic-tools", label: "Diagnostic Tools" },
      { value: "parking-sensors", label: "Parking Sensors" },
      { value: "car-security-systems", label: "Car Security Systems" },
      { value: "car-alarms", label: "Car Alarms" },
      { value: "immobilizers", label: "Immobilizers" },
      { value: "remote-key-systems", label: "Remote Key Systems" },
      { value: "windshield-accessories", label: "Windshield Accessories" },
      { value: "wiper-blades", label: "Wiper Blades" },
      { value: "wiper-accessories", label: "Wiper Accessories" },
      { value: "car-mirrors", label: "Car Mirrors" },
      { value: "replacement-lights", label: "Replacement Lights" },
      { value: "led-headlights", label: "LED Headlights" },
      { value: "fog-lights", label: "Fog Lights" },
      { value: "car-bulbs", label: "Car Bulbs" },
      { value: "interior-lights", label: "Interior Lights" },
      { value: "exterior-lights", label: "Exterior Lights" },
      { value: "number-plate-frames", label: "Number Plate Frames" },
      { value: "license-plate-accessories", label: "License Plate Accessories" },
      { value: "car-stickers", label: "Car Stickers" },
      { value: "car-decals", label: "Car Decals" },
      { value: "automotive-hardware", label: "Automotive Hardware" },
      { value: "garage-accessories", label: "Garage Accessories" },
      { value: "workshop-accessories", label: "Workshop Accessories" },
    ],
  },
  {
    value: "sports",
    label: "Sports",
    commissionRate: 5.9,
    commissionLabel: "Standard tier \u2014 currently 5.9%",
    icon: "\ud83c\udfc3",
    subCategories: [
      { value: "fitness-equipment", label: "Fitness Equipment" },
      { value: "dumbbells", label: "Dumbbells" },
      { value: "kettlebells", label: "Kettlebells" },
      { value: "barbells", label: "Barbells" },
      { value: "weight-plates", label: "Weight Plates" },
      { value: "weight-benches", label: "Weight Benches" },
      { value: "squat-racks", label: "Squat Racks" },
      { value: "resistance-bands", label: "Resistance Bands" },
      { value: "resistance-tubes", label: "Resistance Tubes" },
      { value: "gym-gloves", label: "Gym Gloves" },
      { value: "gym-belts", label: "Gym Belts" },
      { value: "wrist-wraps", label: "Wrist Wraps" },
      { value: "knee-supports", label: "Knee Supports" },
      { value: "elbow-supports", label: "Elbow Supports" },
      { value: "ankle-supports", label: "Ankle Supports" },
      { value: "fitness-mats", label: "Fitness Mats" },
      { value: "yoga-mats", label: "Yoga Mats" },
      { value: "yoga-blocks", label: "Yoga Blocks" },
      { value: "yoga-straps", label: "Yoga Straps" },
      { value: "pilates-equipment", label: "Pilates Equipment" },
      { value: "exercise-bikes", label: "Exercise Bikes" },
      { value: "treadmills", label: "Treadmills" },
      { value: "cross-trainers", label: "Cross Trainers" },
      { value: "rowing-machines", label: "Rowing Machines" },
      { value: "stepper-machines", label: "Stepper Machines" },
      { value: "skipping-ropes", label: "Skipping Ropes" },
      { value: "ab-rollers", label: "Ab Rollers" },
      { value: "pull-up-bars", label: "Pull-Up Bars" },
      { value: "push-up-boards", label: "Push-Up Boards" },
      { value: "hand-grippers", label: "Hand Grippers" },
      { value: "sports-water-bottles", label: "Sports Water Bottles" },
      { value: "sports-towels", label: "Sports Towels" },
      { value: "gym-bags", label: "Gym Bags" },
      { value: "running-accessories", label: "Running Accessories" },
      { value: "running-watches", label: "Running Watches" },
      { value: "running-belts", label: "Running Belts" },
      { value: "running-caps", label: "Running Caps" },
      { value: "running-socks", label: "Running Socks" },
      { value: "running-hydration", label: "Running Hydration" },
      { value: "cycling", label: "Cycling" },
      { value: "bicycles", label: "Bicycles" },
      { value: "road-bikes", label: "Road Bikes" },
      { value: "mountain-bikes", label: "Mountain Bikes" },
      { value: "hybrid-bikes", label: "Hybrid Bikes" },
      { value: "kids-bicycles", label: "Kids Bicycles" },
      { value: "cycling-helmets", label: "Cycling Helmets" },
      { value: "cycling-gloves", label: "Cycling Gloves" },
      { value: "cycling-jerseys", label: "Cycling Jerseys" },
      { value: "cycling-shorts", label: "Cycling Shorts" },
      { value: "cycling-shoes", label: "Cycling Shoes" },
      { value: "football", label: "Football" },
      { value: "footballs", label: "Footballs" },
      { value: "football-shoes", label: "Football Shoes" },
      { value: "football-jerseys", label: "Football Jerseys" },
      { value: "football-shin-guards", label: "Football Shin Guards" },
      { value: "football-gloves", label: "Football Gloves" },
      { value: "cricket", label: "Cricket" },
      { value: "cricket-bats", label: "Cricket Bats" },
      { value: "cricket-balls", label: "Cricket Balls" },
      { value: "cricket-kits", label: "Cricket Kits" },
      { value: "cricket-gloves", label: "Cricket Gloves" },
      { value: "cricket-pads", label: "Cricket Pads" },
      { value: "cricket-helmets", label: "Cricket Helmets" },
      { value: "cricket-shoes", label: "Cricket Shoes" },
      { value: "cricket-bags", label: "Cricket Bags" },
      { value: "badminton", label: "Badminton" },
      { value: "badminton-rackets", label: "Badminton Rackets" },
      { value: "badminton-shuttlecocks", label: "Badminton Shuttlecocks" },
      { value: "badminton-shoes", label: "Badminton Shoes" },
      { value: "badminton-nets", label: "Badminton Nets" },
      { value: "tennis", label: "Tennis" },
      { value: "tennis-rackets", label: "Tennis Rackets" },
      { value: "tennis-balls", label: "Tennis Balls" },
      { value: "tennis-shoes", label: "Tennis Shoes" },
      { value: "tennis-bags", label: "Tennis Bags" },
      { value: "tennis-nets", label: "Tennis Nets" },
      { value: "table-tennis", label: "Table Tennis" },
      { value: "table-tennis-rackets", label: "Table Tennis Rackets" },
      { value: "table-tennis-balls", label: "Table Tennis Balls" },
      { value: "table-tennis-tables", label: "Table Tennis Tables" },
      { value: "table-tennis-nets", label: "Table Tennis Nets" },
      { value: "basketball", label: "Basketball" },
      { value: "basketballs", label: "Basketballs" },
      { value: "basketball-shoes", label: "Basketball Shoes" },
      { value: "basketball-jerseys", label: "Basketball Jerseys" },
      { value: "basketball-hoops", label: "Basketball Hoops" },
      { value: "volleyball", label: "Volleyball" },
      { value: "volleyballs", label: "Volleyballs" },
      { value: "volleyball-nets", label: "Volleyball Nets" },
      { value: "hockey", label: "Hockey" },
      { value: "hockey-sticks", label: "Hockey Sticks" },
      { value: "hockey-balls", label: "Hockey Balls" },
      { value: "hockey-guards", label: "Hockey Guards" },
      { value: "swimming", label: "Swimming" },
      { value: "swimming-goggles", label: "Swimming Goggles" },
      { value: "swimming-caps", label: "Swimming Caps" },
      { value: "swimming-accessories", label: "Swimming Accessories" },
      { value: "golf", label: "Golf" },
      { value: "golf-clubs", label: "Golf Clubs" },
      { value: "golf-balls", label: "Golf Balls" },
      { value: "golf-gloves", label: "Golf Gloves" },
      { value: "golf-bags", label: "Golf Bags" },
      { value: "golf-accessories", label: "Golf Accessories" },
      { value: "hiking", label: "Hiking" },
      { value: "trekking", label: "Trekking" },
      { value: "camping", label: "Camping" },
      { value: "camping-tents", label: "Camping Tents" },
      { value: "sleeping-bags", label: "Sleeping Bags" },
      { value: "camping-chairs", label: "Camping Chairs" },
      { value: "camping-stoves", label: "Camping Stoves" },
      { value: "outdoor-recreation", label: "Outdoor Recreation" },
      { value: "fishing", label: "Fishing" },
      { value: "fishing-rods", label: "Fishing Rods" },
      { value: "fishing-reels", label: "Fishing Reels" },
      { value: "fishing-tackle", label: "Fishing Tackle" },
      { value: "sports-nutrition-accessories", label: "Sports Nutrition Accessories" },
      { value: "martial-arts", label: "Martial Arts" },
      { value: "boxing", label: "Boxing" },
      { value: "boxing-gloves", label: "Boxing Gloves" },
      { value: "punching-bags", label: "Punching Bags" },
      { value: "skating", label: "Skating" },
      { value: "skates", label: "Skates" },
      { value: "skateboards", label: "Skateboards" },
      { value: "outdoor-games", label: "Outdoor Games" },
    ],
  },
  {
    value: "echo-alexa",
    label: "Echo & Alexa Devices",
    commissionRate: 5.0,
    commissionLabel: "Standard tier \u2014 currently 5%",
    icon: "\ud83d\udd0a",
    subCategories: [
      { value: "echo-speakers", label: "Echo Speakers" },
      { value: "echo-dot", label: "Echo Dot" },
      { value: "echo-pop", label: "Echo Pop" },
      { value: "echo-show", label: "Echo Show" },
      { value: "echo-studio", label: "Echo Studio" },
      { value: "echo-auto", label: "Echo Auto" },
      { value: "echo-buds", label: "Echo Buds" },
      { value: "alexa-smart-speakers", label: "Alexa Smart Speakers" },
      { value: "alexa-displays", label: "Alexa Displays" },
      { value: "alexa-compatible-devices", label: "Alexa Compatible Devices" },
      { value: "echo-accessories", label: "Echo Accessories" },
      { value: "echo-stands", label: "Echo Stands" },
      { value: "echo-cases", label: "Echo Cases" },
      { value: "echo-wall-mounts", label: "Echo Wall Mounts" },
      { value: "echo-dot-covers", label: "Echo Dot Covers" },
      { value: "echo-show-stands", label: "Echo Show Stands" },
      { value: "echo-show-covers", label: "Echo Show Covers" },
      { value: "smart-home-hubs", label: "Smart Home Hubs" },
      { value: "alexa-compatible-plugs", label: "Alexa Compatible Plugs" },
      { value: "alexa-compatible-lights", label: "Alexa Compatible Lights" },
      { value: "echo-speakers-for-everyday-use", label: "Echo Speakers \u2014 for Everyday Use" },
      { value: "echo-dot-for-office", label: "Echo Dot \u2014 for Office" },
      { value: "echo-pop-for-travel", label: "Echo Pop \u2014 for Travel" },
      { value: "echo-show-gift-ideas", label: "Echo Show \u2014 Gift Ideas" },
      { value: "echo-studio-premium-picks", label: "Echo Studio \u2014 Premium Picks" },
      { value: "echo-auto-family-use", label: "Echo Auto \u2014 Family Use" },
      { value: "echo-buds-compact-options", label: "Echo Buds \u2014 Compact Options" },
      { value: "alexa-smart-speakers-large-options", label: "Alexa Smart Speakers \u2014 Large Options" },
      { value: "alexa-displays-portable-options", label: "Alexa Displays \u2014 Portable Options" },
      { value: "alexa-compatible-devices-for-everyday-use", label: "Alexa Compatible Devices \u2014 for Everyday Use" },
      { value: "echo-accessories-for-office", label: "Echo Accessories \u2014 for Office" },
      { value: "echo-stands-for-travel", label: "Echo Stands \u2014 for Travel" },
      { value: "echo-cases-gift-ideas", label: "Echo Cases \u2014 Gift Ideas" },
      { value: "echo-wall-mounts-premium-picks", label: "Echo Wall Mounts \u2014 Premium Picks" },
      { value: "echo-dot-covers-family-use", label: "Echo Dot Covers \u2014 Family Use" },
      { value: "echo-show-stands-compact-options", label: "Echo Show Stands \u2014 Compact Options" },
      { value: "echo-show-covers-large-options", label: "Echo Show Covers \u2014 Large Options" },
      { value: "smart-home-hubs-portable-options", label: "Smart Home Hubs \u2014 Portable Options" },
      { value: "alexa-compatible-plugs-for-everyday-use", label: "Alexa Compatible Plugs \u2014 for Everyday Use" },
      { value: "alexa-compatible-lights-for-office", label: "Alexa Compatible Lights \u2014 for Office" },
      { value: "echo-speakers-for-travel", label: "Echo Speakers \u2014 for Travel" },
      { value: "echo-dot-gift-ideas", label: "Echo Dot \u2014 Gift Ideas" },
      { value: "echo-pop-premium-picks", label: "Echo Pop \u2014 Premium Picks" },
      { value: "echo-show-family-use", label: "Echo Show \u2014 Family Use" },
      { value: "echo-studio-compact-options", label: "Echo Studio \u2014 Compact Options" },
      { value: "echo-auto-large-options", label: "Echo Auto \u2014 Large Options" },
      { value: "echo-buds-portable-options", label: "Echo Buds \u2014 Portable Options" },
      { value: "alexa-smart-speakers-for-everyday-use", label: "Alexa Smart Speakers \u2014 for Everyday Use" },
      { value: "alexa-displays-for-office", label: "Alexa Displays \u2014 for Office" },
      { value: "alexa-compatible-devices-for-travel", label: "Alexa Compatible Devices \u2014 for Travel" },
      { value: "echo-accessories-gift-ideas", label: "Echo Accessories \u2014 Gift Ideas" },
      { value: "echo-stands-premium-picks", label: "Echo Stands \u2014 Premium Picks" },
      { value: "echo-cases-family-use", label: "Echo Cases \u2014 Family Use" },
      { value: "echo-wall-mounts-compact-options", label: "Echo Wall Mounts \u2014 Compact Options" },
      { value: "echo-dot-covers-large-options", label: "Echo Dot Covers \u2014 Large Options" },
      { value: "echo-show-stands-portable-options", label: "Echo Show Stands \u2014 Portable Options" },
      { value: "echo-show-covers-for-everyday-use", label: "Echo Show Covers \u2014 for Everyday Use" },
      { value: "smart-home-hubs-for-office", label: "Smart Home Hubs \u2014 for Office" },
      { value: "alexa-compatible-plugs-for-travel", label: "Alexa Compatible Plugs \u2014 for Travel" },
      { value: "alexa-compatible-lights-gift-ideas", label: "Alexa Compatible Lights \u2014 Gift Ideas" },
      { value: "echo-speakers-premium-picks", label: "Echo Speakers \u2014 Premium Picks" },
      { value: "echo-dot-family-use", label: "Echo Dot \u2014 Family Use" },
      { value: "echo-pop-compact-options", label: "Echo Pop \u2014 Compact Options" },
      { value: "echo-show-large-options", label: "Echo Show \u2014 Large Options" },
      { value: "echo-studio-portable-options", label: "Echo Studio \u2014 Portable Options" },
      { value: "echo-auto-for-everyday-use", label: "Echo Auto \u2014 for Everyday Use" },
      { value: "echo-buds-for-office", label: "Echo Buds \u2014 for Office" },
      { value: "alexa-smart-speakers-for-travel", label: "Alexa Smart Speakers \u2014 for Travel" },
      { value: "alexa-displays-gift-ideas", label: "Alexa Displays \u2014 Gift Ideas" },
      { value: "alexa-compatible-devices-premium-picks", label: "Alexa Compatible Devices \u2014 Premium Picks" },
      { value: "echo-accessories-family-use", label: "Echo Accessories \u2014 Family Use" },
      { value: "echo-stands-compact-options", label: "Echo Stands \u2014 Compact Options" },
      { value: "echo-cases-large-options", label: "Echo Cases \u2014 Large Options" },
      { value: "echo-wall-mounts-portable-options", label: "Echo Wall Mounts \u2014 Portable Options" },
      { value: "echo-dot-covers-for-everyday-use", label: "Echo Dot Covers \u2014 for Everyday Use" },
      { value: "echo-show-stands-for-office", label: "Echo Show Stands \u2014 for Office" },
      { value: "echo-show-covers-for-travel", label: "Echo Show Covers \u2014 for Travel" },
      { value: "smart-home-hubs-gift-ideas", label: "Smart Home Hubs \u2014 Gift Ideas" },
      { value: "alexa-compatible-plugs-premium-picks", label: "Alexa Compatible Plugs \u2014 Premium Picks" },
      { value: "alexa-compatible-lights-family-use", label: "Alexa Compatible Lights \u2014 Family Use" },
      { value: "echo-speakers-compact-options", label: "Echo Speakers \u2014 Compact Options" },
      { value: "echo-dot-large-options", label: "Echo Dot \u2014 Large Options" },
      { value: "echo-pop-portable-options", label: "Echo Pop \u2014 Portable Options" },
      { value: "echo-show-for-everyday-use", label: "Echo Show \u2014 for Everyday Use" },
      { value: "echo-studio-for-office", label: "Echo Studio \u2014 for Office" },
      { value: "echo-auto-for-travel", label: "Echo Auto \u2014 for Travel" },
      { value: "echo-buds-gift-ideas", label: "Echo Buds \u2014 Gift Ideas" },
      { value: "alexa-smart-speakers-premium-picks", label: "Alexa Smart Speakers \u2014 Premium Picks" },
      { value: "alexa-displays-family-use", label: "Alexa Displays \u2014 Family Use" },
      { value: "alexa-compatible-devices-compact-options", label: "Alexa Compatible Devices \u2014 Compact Options" },
    ],
  },
  {
    value: "fire-tv",
    label: "Fire TV Devices",
    commissionRate: 5.0,
    commissionLabel: "Standard tier \u2014 currently 5%",
    icon: "\ud83d\udcfa",
    subCategories: [
      { value: "fire-tv-stick", label: "Fire TV Stick" },
      { value: "fire-tv-stick-lite", label: "Fire TV Stick Lite" },
      { value: "fire-tv-stick-4k", label: "Fire TV Stick 4K" },
      { value: "fire-tv-stick-4k-max", label: "Fire TV Stick 4K Max" },
      { value: "fire-tv-cube", label: "Fire TV Cube" },
      { value: "fire-tv-accessories", label: "Fire TV Accessories" },
      { value: "fire-tv-remotes", label: "Fire TV Remotes" },
      { value: "fire-tv-remote-covers", label: "Fire TV Remote Covers" },
      { value: "fire-tv-hdmi-accessories", label: "Fire TV HDMI Accessories" },
      { value: "fire-tv-ethernet-adapters", label: "Fire TV Ethernet Adapters" },
      { value: "fire-tv-usb-accessories", label: "Fire TV USB Accessories" },
      { value: "fire-tv-power-adapters", label: "Fire TV Power Adapters" },
      { value: "fire-tv-wall-mounts", label: "Fire TV Wall Mounts" },
      { value: "fire-tv-stands", label: "Fire TV Stands" },
      { value: "fire-tv-replacement-remotes", label: "Fire TV Replacement Remotes" },
      { value: "fire-tv-streaming-accessories", label: "Fire TV Streaming Accessories" },
      { value: "fire-tv-compatible-controllers", label: "Fire TV Compatible Controllers" },
      { value: "fire-tv-gaming-accessories", label: "Fire TV Gaming Accessories" },
      { value: "fire-tv-cables", label: "Fire TV Cables" },
      { value: "fire-tv-display-accessories", label: "Fire TV Display Accessories" },
      { value: "fire-tv-stick-for-everyday-use", label: "Fire TV Stick \u2014 for Everyday Use" },
      { value: "fire-tv-stick-lite-for-office", label: "Fire TV Stick Lite \u2014 for Office" },
      { value: "fire-tv-stick-4k-for-travel", label: "Fire TV Stick 4K \u2014 for Travel" },
      { value: "fire-tv-stick-4k-max-gift-ideas", label: "Fire TV Stick 4K Max \u2014 Gift Ideas" },
      { value: "fire-tv-cube-premium-picks", label: "Fire TV Cube \u2014 Premium Picks" },
      { value: "fire-tv-accessories-family-use", label: "Fire TV Accessories \u2014 Family Use" },
      { value: "fire-tv-remotes-compact-options", label: "Fire TV Remotes \u2014 Compact Options" },
      { value: "fire-tv-remote-covers-large-options", label: "Fire TV Remote Covers \u2014 Large Options" },
      { value: "fire-tv-hdmi-accessories-portable-options", label: "Fire TV HDMI Accessories \u2014 Portable Options" },
      { value: "fire-tv-ethernet-adapters-for-everyday-use", label: "Fire TV Ethernet Adapters \u2014 for Everyday Use" },
      { value: "fire-tv-usb-accessories-for-office", label: "Fire TV USB Accessories \u2014 for Office" },
      { value: "fire-tv-power-adapters-for-travel", label: "Fire TV Power Adapters \u2014 for Travel" },
      { value: "fire-tv-wall-mounts-gift-ideas", label: "Fire TV Wall Mounts \u2014 Gift Ideas" },
      { value: "fire-tv-stands-premium-picks", label: "Fire TV Stands \u2014 Premium Picks" },
      { value: "fire-tv-replacement-remotes-family-use", label: "Fire TV Replacement Remotes \u2014 Family Use" },
      { value: "fire-tv-streaming-accessories-compact-options", label: "Fire TV Streaming Accessories \u2014 Compact Options" },
      { value: "fire-tv-compatible-controllers-large-options", label: "Fire TV Compatible Controllers \u2014 Large Options" },
      { value: "fire-tv-gaming-accessories-portable-options", label: "Fire TV Gaming Accessories \u2014 Portable Options" },
      { value: "fire-tv-cables-for-everyday-use", label: "Fire TV Cables \u2014 for Everyday Use" },
      { value: "fire-tv-display-accessories-for-office", label: "Fire TV Display Accessories \u2014 for Office" },
      { value: "fire-tv-stick-for-travel", label: "Fire TV Stick \u2014 for Travel" },
      { value: "fire-tv-stick-lite-gift-ideas", label: "Fire TV Stick Lite \u2014 Gift Ideas" },
      { value: "fire-tv-stick-4k-premium-picks", label: "Fire TV Stick 4K \u2014 Premium Picks" },
      { value: "fire-tv-stick-4k-max-family-use", label: "Fire TV Stick 4K Max \u2014 Family Use" },
      { value: "fire-tv-cube-compact-options", label: "Fire TV Cube \u2014 Compact Options" },
      { value: "fire-tv-accessories-large-options", label: "Fire TV Accessories \u2014 Large Options" },
      { value: "fire-tv-remotes-portable-options", label: "Fire TV Remotes \u2014 Portable Options" },
      { value: "fire-tv-remote-covers-for-everyday-use", label: "Fire TV Remote Covers \u2014 for Everyday Use" },
      { value: "fire-tv-hdmi-accessories-for-office", label: "Fire TV HDMI Accessories \u2014 for Office" },
      { value: "fire-tv-ethernet-adapters-for-travel", label: "Fire TV Ethernet Adapters \u2014 for Travel" },
      { value: "fire-tv-usb-accessories-gift-ideas", label: "Fire TV USB Accessories \u2014 Gift Ideas" },
      { value: "fire-tv-power-adapters-premium-picks", label: "Fire TV Power Adapters \u2014 Premium Picks" },
      { value: "fire-tv-wall-mounts-family-use", label: "Fire TV Wall Mounts \u2014 Family Use" },
      { value: "fire-tv-stands-compact-options", label: "Fire TV Stands \u2014 Compact Options" },
      { value: "fire-tv-replacement-remotes-large-options", label: "Fire TV Replacement Remotes \u2014 Large Options" },
      { value: "fire-tv-streaming-accessories-portable-options", label: "Fire TV Streaming Accessories \u2014 Portable Options" },
      { value: "fire-tv-compatible-controllers-for-everyday-use", label: "Fire TV Compatible Controllers \u2014 for Everyday Use" },
      { value: "fire-tv-gaming-accessories-for-office", label: "Fire TV Gaming Accessories \u2014 for Office" },
      { value: "fire-tv-cables-for-travel", label: "Fire TV Cables \u2014 for Travel" },
      { value: "fire-tv-display-accessories-gift-ideas", label: "Fire TV Display Accessories \u2014 Gift Ideas" },
      { value: "fire-tv-stick-premium-picks", label: "Fire TV Stick \u2014 Premium Picks" },
      { value: "fire-tv-stick-lite-family-use", label: "Fire TV Stick Lite \u2014 Family Use" },
      { value: "fire-tv-stick-4k-compact-options", label: "Fire TV Stick 4K \u2014 Compact Options" },
      { value: "fire-tv-stick-4k-max-large-options", label: "Fire TV Stick 4K Max \u2014 Large Options" },
      { value: "fire-tv-cube-portable-options", label: "Fire TV Cube \u2014 Portable Options" },
      { value: "fire-tv-accessories-for-everyday-use", label: "Fire TV Accessories \u2014 for Everyday Use" },
      { value: "fire-tv-remotes-for-office", label: "Fire TV Remotes \u2014 for Office" },
      { value: "fire-tv-remote-covers-for-travel", label: "Fire TV Remote Covers \u2014 for Travel" },
      { value: "fire-tv-hdmi-accessories-gift-ideas", label: "Fire TV HDMI Accessories \u2014 Gift Ideas" },
      { value: "fire-tv-ethernet-adapters-premium-picks", label: "Fire TV Ethernet Adapters \u2014 Premium Picks" },
      { value: "fire-tv-usb-accessories-family-use", label: "Fire TV USB Accessories \u2014 Family Use" },
      { value: "fire-tv-power-adapters-compact-options", label: "Fire TV Power Adapters \u2014 Compact Options" },
      { value: "fire-tv-wall-mounts-large-options", label: "Fire TV Wall Mounts \u2014 Large Options" },
      { value: "fire-tv-stands-portable-options", label: "Fire TV Stands \u2014 Portable Options" },
      { value: "fire-tv-replacement-remotes-for-everyday-use", label: "Fire TV Replacement Remotes \u2014 for Everyday Use" },
      { value: "fire-tv-streaming-accessories-for-office", label: "Fire TV Streaming Accessories \u2014 for Office" },
      { value: "fire-tv-compatible-controllers-for-travel", label: "Fire TV Compatible Controllers \u2014 for Travel" },
      { value: "fire-tv-gaming-accessories-gift-ideas", label: "Fire TV Gaming Accessories \u2014 Gift Ideas" },
      { value: "fire-tv-cables-premium-picks", label: "Fire TV Cables \u2014 Premium Picks" },
      { value: "fire-tv-display-accessories-family-use", label: "Fire TV Display Accessories \u2014 Family Use" },
      { value: "fire-tv-stick-compact-options", label: "Fire TV Stick \u2014 Compact Options" },
      { value: "fire-tv-stick-lite-large-options", label: "Fire TV Stick Lite \u2014 Large Options" },
      { value: "fire-tv-stick-4k-portable-options", label: "Fire TV Stick 4K \u2014 Portable Options" },
      { value: "fire-tv-stick-4k-max-for-everyday-use", label: "Fire TV Stick 4K Max \u2014 for Everyday Use" },
      { value: "fire-tv-cube-for-office", label: "Fire TV Cube \u2014 for Office" },
      { value: "fire-tv-accessories-for-travel", label: "Fire TV Accessories \u2014 for Travel" },
      { value: "fire-tv-remotes-gift-ideas", label: "Fire TV Remotes \u2014 Gift Ideas" },
      { value: "fire-tv-remote-covers-premium-picks", label: "Fire TV Remote Covers \u2014 Premium Picks" },
      { value: "fire-tv-hdmi-accessories-family-use", label: "Fire TV HDMI Accessories \u2014 Family Use" },
      { value: "fire-tv-ethernet-adapters-compact-options", label: "Fire TV Ethernet Adapters \u2014 Compact Options" },
    ],
  },
];

export const getCategory = (value: string) => PRODUCT_CATEGORIES.find((item) => item.value === value);
export const getCategoryLabel = (value: string) => getCategory(value)?.label || value;
export const getSubCategory = (categoryValue: string, subCategoryValue?: string) => getCategory(categoryValue)?.subCategories.find((item) => item.value === subCategoryValue);
export const getCategoryOptionCount = () => PRODUCT_CATEGORIES.reduce((total, item) => total + item.subCategories.length, 0);
